// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* New theme setting */
.shopify-integration-setting-visual-editor .Polaris-FullscreenBar {
  z-index: 517;
  box-shadow: 0px 0px 1px 0px #00000040, 0px 2px 1px 0px #0000000d;
}

.shopify-integration-setting-visual-editor .Polaris-Frame__Content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.shopify-integration-setting-visual-editor .visual-editor-header {
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0 1rem;
}

.shopify-integration-setting-visual-editor .visual-editor-header .theme-name {
  display: flex;
  align-items: center;
  width: 250px;
}

.shopify-integration-setting-visual-editor .visual-editor-header .theme-name p {
  font-size: 14px;
  line-height: 20px;
}

.shopify-integration-setting-visual-editor .visual-editor-header .theme-name p {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.shopify-integration-setting-visual-editor .visual-editor-header .theme-name .Polaris-Badge {
  background: #ebf9fc;
  color: #2c6ecb;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  margin-left: 8px;
  flex-shrink: 0;
}

.shopify-integration-setting-visual-editor .visual-editor-header .theme-action {
  display: flex;
  align-items: center;
}

.shopify-integration-setting-visual-editor
  .visual-editor-header
  .visual-editor-header--color-picker {
  width: 36px;
  height: 36px;
  margin-left: 24px;
  cursor: pointer;
}

.shopify-integration-setting-visual-editor
  .visual-editor-header
  .visual-editor-header--color-picker:hover {
  background-color: #f6f6f7;
}

.shopify-integration-setting-visual-editor .Polaris-FullscreenBar__BackAction {
  display: none;
}

.shopify-integration-setting-visual-editor .BC-BackAction {
  display: flex;
  padding: 0 16px;
  border-right: 1px solid #e1e3e5 !important;
}

.shopify-integration-setting-visual-editor .BC-BackAction .Polaris-Icon {
  margin: 0 !important;
}

.shopify-integration-setting-popover-menu {
  min-width: 198px;
}

.shopify-integration-setting-popover-menu .Polaris-ActionList__Item:hover {
  background-color: #ecf6f1;
}

.shopify-integration-setting-visual-editor
  .visual-editor-header__action
  .Polaris-ButtonGroup__Item {
  margin-left: 16px;
}

.shopify-integration-setting-visual-editor .btn-dots {
  border-radius: 4px;
  border: 1px solid #babfc3;
}

.shopify-integration-setting-visual-editor .btn-dots button {
  background-color: #fff !important;
  padding: 8px 9px;
}

.shopify-integration-setting-visual-editor .btn-dots:hover button {
  background-color: #f1f2f3 !important;
}

.shopify-integration-setting-visual-editor .visual-editor-body {
  width: 100%;
  display: flex;
  height: calc(100vh - 56px);
}

.shopify-integration-setting-visual-editor .visual-editor-body.warning {
  height: calc(100vh - 104px);
}

.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-settings {
  width: 300px;
  height: 100%;
  background: #ffffff;
  border-right: 1px solid #e1e3e5;
  overflow: auto;
}

.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-preview {
  /* transition: 0.4s all ease-in-out; */
  position: relative;
  /* overflow: unset;
  overflow-x: hidden; */
}

@media screen and (max-width: 1440px) {
  .shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-preview {
    padding: 0 8px;
  }
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  #preview-shopify-integration-setting {
  width: 100%;
  height: 100%;
  border: none;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  #preview-shopify-integration-setting-quickview {
  position: fixed;
  top: 54px;
  left: 350px;
  width: calc(100% - 350px);
  height: calc(100% - 54px);
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  #preview-shopify-integration-setting-quickview.preview-quickview--mobile {
  width: 375px;
  top: 56px;
  left: 50%;
  border: 0;
  height: calc(100% - 56px);
}
.shopify-integration-setting-visual-editor
  .visual-editor-body
  #preview-shopify-integration-setting-quickview.preview-quickview--fullscreen {
  width: 100%;
  left: 0;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  #preview-shopify-integration-setting-cart.preview-cart--mobile {
  width: 497px;
  top: 54px;  
  left: 45%;
  border: 0;
  height: calc(100% - 54px);
}
.shopify-integration-setting-visual-editor
  .visual-editor-body
  #preview-shopify-integration-setting-cart.preview-cart--mobile.preview-cart--side {
  width: 340px;
  left: 50%;
}
.shopify-integration-setting-visual-editor
  .visual-editor-body
  #preview-shopify-integration-setting-cart.preview-cart--fullscreen {
  width: 100%;
  left: 0;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  #preview-shopify-integration-setting-cart {
  position: fixed;
  top: 54px;
  left: 350px;
  width: calc(100% - 350px);
  height: calc(100% - 54px);
}

.shopify-integration-setting-visual-editor .visual-editor-body.desktop .visual-editor-preview {
  width: calc(100% - 352px);
}

.shopify-integration-setting-visual-editor .visual-editor-body.mobile .visual-editor-preview {
  width: 375px !important;
  margin: 0 auto;
}

.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-preview.full {
  width: 100%;
  left: 0;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview.overflow-hidden {
  overflow: hidden;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview
  .boost-sd__filter-block {
  width: calc(100%);
  /* transition: 0.4s all ease-in-out; */
  position: relative;
  height: 100%;
  overflow: auto;
}

.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-preview .btn-expand {
  width: 60px;
  height: 60px;
  background: #fafbfb;
  border-width: 0px 0px 1px 1px;
  border-style: solid;
  border-color: #e1e3e5;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.1);
  transition: 0.3s all ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  transform: translate(80px, 0);
  z-index: 516;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview
  .btn-expand.show {
  transform: translate(0, 0);
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview.overflow-hidden
  .btn-expand.show {
  box-shadow: none;
  border-bottom: none;
}

.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-preview .loading {
  position: fixed;
  top: 0;
  left: 300px;
  z-index: 99;
  width: calc(100% - 600px);
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview.full
  .loading {
  width: calc(100% - 300px);
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview
  .loading
  .Polaris-Spinner
  svg {
  fill: white;
}

.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-left-panel-container {
  display: flex;
  width: 0;
  height: 100%;
  background: #ffffff;
  border-left: 1px solid #e1e3e5;
  /* transition: 0.3s all ease-in-out; */
  /* position: fixed;
  top: 56px;
  left: 0; */
  transform: translate(-360px, 0);
  z-index: 500;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-left-panel-container.opened {
  transform: translate(0, 0);
  width: 352px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel-container {
  width: 300px;
  height: 100%;
  background: #ffffff;
  border-left: 1px solid #e1e3e5;
  position: relative;
  transition: 0.3s all ease-in-out;
  position: fixed;
  top: 56px;
  right: 0;
  transform: translate(360px, 0);
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel-container.opened {
  transform: translate(0, 0);
}

.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-right-panel__scroll {
  overflow: auto;
  height: calc(100% - 108px);
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__scroll.not-remove {
  height: calc(100% - 56px);
}

.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-right-panel {
  margin-top: -1rem;
  min-height: calc(100% - 60px);
  padding: 1rem;
  padding-top: 0;
  padding-bottom: 1px;
}

.shopify-integration-setting-visual-editor .visual-editor-body .form-container .default-text-style {
  font-weight: 400 !important;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel
  .Polaris-Label__Text--disabled {
  color: #8c9196;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel
  .visual-editor-right-panel__content.h-full {
  max-height: 100%;
}

.shopify-integration-setting-visual-editor .visual-editor-body .form-container .Polaris-FormLayout {
  margin-top: 0;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section.form-section--bordered {
  box-shadow: inset 0px 1px 0px #e4e5e7;
  margin: 0 -16px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .section-title-collapse__wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 16px;
  cursor: pointer;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .section-title-collapse__wrapper
  .section-title {
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #6d7175;
  margin: 0 !important;
  display: flex;
  align-items: center;
  text-transform: uppercase;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .section-title-collapse__wrapper
  .section-title.uppercase {
  text-transform: uppercase;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .section-title-collapse__wrapper
  .section-title
  .Polaris-Icon {
  display: flex;
  align-items: center;
  max-width: max-content;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .section-title-collapse__wrapper
  .section-title
  .Polaris-Icon__Svg {
  width: 14px;
  height: 14px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .section-title-collapse__wrapper
  .caret {
  transition: 0.3s all;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .section-title-collapse__wrapper
  .caret.closed {
  transform: rotate(180deg);
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .section-title-collapse__wrapper
  .caret.collapsed {
  transform: rotate(90deg);
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .ReactCollapse--collapse {
  padding: 0 16px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .ReactCollapse--collapse[aria-hidden='false'] {
  margin-bottom: 20px;
}

.shopify-integration-setting-visual-editor .visual-editor-body .form-container .form-title {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-title
  .Polaris-Icon {
  margin: 0;
  width: 12px;
  height: 12px;
  position: relative;
  top: 2px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .title {
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  margin-bottom: 8px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section__item
  .title {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 4px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section__item
  .title.title--small {
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  margin-bottom: 8px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .form-section__item
  + .form-section__item {
  margin-top: 8px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .form-section__item
  .Polaris-Connected__Item:first-child {
  align-self: center;
  width: calc(100% - 34px - 58px);
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .form-section__item
  .Polaris-Connected__Item:last-child {
  margin-left: 0;
  width: 34px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .form-section__item.form-section__item--slider
  .Polaris-TextField__Backdrop {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .form-section__item
  .Polaris-Connected__Item
  .Polaris-TextField__Input {
  padding-top: 5px;
  padding-bottom: 5px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .form-section__item
  .Polaris-Connected__Item--primary {
  width: 58px;
  min-width: 58px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .form-section__item
  .text-field-unit {
  border-radius: 0px 4px 4px 0px;
  background: #f1f2f3;
  border: 1px solid #babfc3;
  border-left: 0;
  box-shadow: inset 0px 2px 0px rgba(0, 0, 0, 0.05);
  padding: 7px 8px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .form-section__item
  .text-field-unit
  span {
  position: relative;
  top: -1px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .form-section__item
  .Polaris-RangeSlider-SingleThumb__Input {
  --pc-single-thumb-progress-lower: #008060;
  --p-focused: transparent;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .form-section__item
  .Polaris-RangeSlider-SingleThumb__Input::-webkit-slider-thumb {
  background: #008060;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .form-section__item
  .Polaris-RangeSlider-SingleThumb--disabled
  .Polaris-RangeSlider-SingleThumb__Input::-webkit-slider-thumb {
  background: #f1f1f1 !important;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .form-section__item
  .Polaris-RangeSlider-SingleThumb__Input::-moz-range-thumb {
  background: #008060;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .form-section__item
  .Polaris-RangeSlider-SingleThumb--disabled
  .Polaris-RangeSlider-SingleThumb__Input::-moz-range-thumb {
  background: #f1f1f1 !important;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .form-section__item.form-section__item--small-spacing {
  margin-top: 5px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .form-section__item.form-section__item--medium-spacing {
  margin-top: 12px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .form-section__item.form-section__item--standard-spacing {
  margin-top: 16px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .form-section__item
  .Polaris-TextField__Input {
  padding-top: 6px;
  padding-bottom: 6px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .form-section__item.form-section__item--bordered-top {
  border-top: 1px solid #e1e3e5;
  padding-top: 16px;
  margin-top: 20px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .form-section__item
  > .title--medium {
  font-weight: 600;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .BC-ThemeSettings_Dropzone {
  padding: 25px 47px;
  background: #f1f2f3;
  border-radius: 4px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .BC-ThemeSettings_Dropzone
  .custom-dropzone-standard-v2
  .Polaris-DropZone__Container
  > div {
  padding: 24px 12px 16px !important;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .BC-ThemeSettings_Dropzone
  .custom-dropzone-standard-v2.uploaded
  .Polaris-DropZone__Container
  > div {
  padding: 24px 12px 8px !important;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .BC-ThemeSettings_Dropzone
  .Polaris-Stack__Item
  .Polaris-Stack__Item {
  margin-top: 4px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .BC-ThemeSettings_Dropzone
  .Polaris-TextStyle--variationSubdued {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #8c9196;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .BC-ThemeSettings_Dropzone
  .Polaris-DropZone--hasOutline:not(.Polaris-DropZone--focused)::after {
  border-radius: 4px;
  border: 1px solid #babfc3;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .BC-ThemeSettings_Dropzone
  .Polaris-DropZone
  .Polaris-TextStyle--variationSubdued {
  color: #202223;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .BC-ThemeSettings_Dropzone
  .Polaris-DropZone.Polaris-DropZone--isDisabled
  .Polaris-TextStyle--variationSubdued {
  color: #8c9196;
}

.shopify-integration-setting-visual-editor .visual-editor-body .form-container .form-link {
  color: #2c6ecb;
  align-items: center;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-link
  a:visited {
  color: #2c6ecb;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-link
  .Polaris-Icon {
  margin: 0;
  margin-left: 2px;
  display: inline-block;
  position: relative;
  top: 2.5px;
  width: 15px;
  height: 15px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-link
  .Polaris-Icon
  svg {
  fill: #2c6ecb;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-link.form-link--normal
  .Polaris-Icon
  svg {
  fill: #5c5f62;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-link.form-link--normal
  .Polaris-Icon {
  top: 1px;
  margin-left: 0;
  width: 14px;
  height: 14px;
}

.form-link__product-image-area-tooltip .form-link__product-image-area-tooltip__top {
  width: 142px;
  height: 145px;
  display: flex;
  flex-direction: column;
  gap: 14.44px;
  background-image: url('https://cdn.boostcommerce.io/assets/theme-setting/sample.svg');
  background-size: 100% 100%;
  background-color: #edeeef;
}

.form-link__product-image-area-tooltip
  .form-link__product-image-area-tooltip__top
  .form-link__product-image-area-tooltip__item {
  width: 100%;
  height: 38px;
  border-radius: 4px;
  border: 1.455px dashed #5c5f62;
  background: rgba(255, 255, 255, 0.7);
}

.form-link__product-image-area-tooltip
  .form-link__product-image-area-tooltip__top
  .form-link__product-image-area-tooltip__item.active {
  background: #2c6ecb;
  border-color: transparent;
}

.form-link__product-image-area-tooltip .form-link__product-image-area-tooltip__body {
  margin-top: 8.73px;
}

.form-link__product-image-area-tooltip .form-link__product-image-area-tooltip__body .name {
  font-size: 10.182px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.102px;
}

.form-link__product-image-area-tooltip .form-link__product-image-area-tooltip__body .vendor {
  font-size: 8px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.4px;
  margin-top: 3px;
  color: #7d7d7d;
}

.form-link__product-image-area-tooltip .form-link__product-image-area-tooltip__body .price {
  font-family: Poppins;
  font-size: 11.636px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.582px;
  margin-top: 6px;
}

.shopify-integration-setting-visual-editor .visual-editor-body .form-container .icon-app-rating {
  width: 32px;
  height: 32px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .icon-app-rating
  img {
  max-width: 100%;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .input-wrapper-suffix {
  position: relative;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .input-wrapper-suffix
  > div:first-child {
  z-index: 1;
  position: relative;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .input-wrapper-suffix
  .Polaris-TextField__Input {
  padding-right: 50px;
  min-height: 48px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .input-wrapper-suffix
  .select-borderless {
  position: absolute;
  bottom: 8px;
  right: 8px;
  z-index: 10;
  background-color: transparent;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .input-wrapper-suffix
  .select-borderless
  > div
  > div {
  width: max-content;
  border: none !important;
  box-shadow: none !important;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .input-wrapper-suffix
  .select-borderless
  .BC-Select__control {
  min-height: auto;
  width: 32px;
  height: 32px;
  cursor: pointer;
  border: none !important;
  box-shadow: none !important;
  background: #f1f2f3;
  border-radius: 4px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .input-wrapper-suffix
  .select-borderless
  .BC-Select__control
  .BC-Select__value-container {
  justify-content: center;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .input-wrapper-suffix
  .select-borderless
  .BC-Select__control
  .BC-Select__placeholder {
  font-size: 18px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .BC-Select__control--is-disabled {
  background: #fafbfb;
  border: 1px solid #c9cccf;
  opacity: 0.6;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .BC-Select__control--is-disabled
  .BC-Select__placeholder {
  color: #8c9196;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .BC-Select__control--is-disabled
  .BC-Select__indicator
  .Polaris-Icon__Svg {
  fill: #8c9196;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section
  .BC-Select__single-value
  .help-text {
  display: none;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview:has(.visual-editor-preview__overlay)
  .loading {
  display: none;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview:has(.visual-editor-preview__overlay)
  .boost-sd__filter-block {
  overflow: hidden;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview
  .visual-editor-preview__overlay-cart,
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview
  .visual-editor-preview__overlay.mobile {
  width: 100%;
  background-color: rgb(34, 34, 34, 0.6);
  position: fixed;
  z-index: 50;
  top: 0;
  left: 0;
  height: 100%;
  overflow: hidden;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview.full
  .visual-editor-preview__overlay {
  width: 100%;
  /* overflow: unset; */
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview
  .visual-editor-preview__overlay
  .boost-sd__modal-close-btn--on-overlay {
  top: 56px;
}

.product-gallery--vertical .product-gallery__pagination-wrapper .Polaris-Icon {
  transform: rotate(-90deg);
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview
  .boost-sd__modal-backdrop {
  background-color: transparent;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview
  .boost-sd__cart:not(.boost-sd__cart--side) {
  height: initial;
  max-height: min(640px, calc(100% - 120px));
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview
  .boost-sd__cart:not(.boost-sd__cart--side)
  .boost-sd__cart-body {
  height: 340px;
}

.BC-Select__option {
  border-radius: 4px;
  margin-top: 4px;
}

.BC-Select__option:first-child {
  margin-top: 0px !important;
}

.BC-Select__option:not(.BC-Select__option--is-selected) .help-text {
  color: #6d7175;
}

.BC-Select__option.BC-Select__option--is-selected .help-text {
  color: white;
}

.shopify-integration-setting-visual-editor .visual-editor-body .grid-radio-button__wrapper {
  background-color: #fafbfb;
  padding: 8px;
  border: 1px solid #c9cccf;
  border-radius: 4px;
}

.shopify-integration-setting-visual-editor .visual-editor-body .grid-radio-button {
  margin: auto;
  width: 140px;
  min-width: 140px;
  display: grid;
  grid-template-columns: 44px 44px 44px;
  gap: 4px;
}

.shopify-integration-setting-visual-editor .visual-editor-body .grid-radio-button .Polaris-Button {
  height: 44px;
}

.shopify-integration-setting-visual-editor .visual-editor-body .radio-button-wrapper {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 8px;
  margin-top: 4px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper.radio-button-wrapper--no-gap {
  column-gap: 0;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper
  .radio-button-2
  .Polaris-Button {
  padding: 8px 16px;
  position: relative;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper.radio-button-wrapper--full-width
  .radio-button-2 {
  width: 100% !important;
  flex-grow: 1 !important;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper.radio-button-wrapper--full-width
  .radio-button-2
  .Polaris-Button {
  padding: 8px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper.radio-button-wrapper--no-wrap {
  flex-wrap: nowrap;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper.radio-button-wrapper--no-gap
  .radio-button-2:first-child
  .Polaris-Button {
  border-right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper.radio-button-wrapper--no-gap
  .radio-button-2:last-child
  .Polaris-Button {
  border-left: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper.radio-button-wrapper--no-radius-middle
  .radio-button-2:nth-child(2)
  .Polaris-Button {
  border-radius: 0;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper.radio-button-wrapper--bordered
  .radio-button-2:first-child
  .Polaris-Button {
  border-right: var(--p-border-width-1) solid var(--p-border-neutral-subdued);
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper.radio-button-wrapper--outline
  .radio-button-2
  .Polaris-Button.checked {
  background-color: #fff;
  border-color: #008060;
  border-width: 2px;
  color: #008060;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper.radio-button-wrapper--outline
  .radio-button-2
  .Polaris-Button.checked
  .Polaris-Icon__Svg
  rect,
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper.radio-button-wrapper--outline
  .radio-button-2
  .Polaris-Button.checked
  .Polaris-Icon__Svg
  path {
  fill: #008060;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper
  .radio-button-2
  .Polaris-Button.checked
  .icon-check {
  position: absolute;
  top: -8px;
  right: -8px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-sidebar
  .__react_component_tooltip,
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu
  .menu-title
  .__react_component_tooltip {
  box-shadow: 0px 2px 10px 0px #0000001a, 0px 0px 2px 0px #00000033;
  max-width: 25rem;
  padding: var(--p-space-1) var(--p-space-2);
  opacity: 1;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper
  .radio-button-2
  .__react_component_tooltip {
  box-shadow: 0px 2px 10px 0px #0000001a, 0px 0px 2px 0px #00000033;
  max-width: 25rem;
  padding: var(--p-space-1) var(--p-space-2);
}

.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-menu .color-form,
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu
  .typography-section {
  position: relative;
  height: 100%;
}

.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-menu .btn-reset,
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu
  .typography-section
  .btn-reset {
  position: absolute;
  left: 52px;
  bottom: 0;
  width: calc(100% - 53px);
  padding: 16px 0;
  border-top: 1px solid #e1e3e5;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  cursor: pointer;
  color: #2c6ecb;
  background-color: #fff;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu
  .color-form
  .btn-reset
  svg,
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu
  .typography-section
  .btn-reset
  svg {
  width: 16px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu
  .color-form
  .btn-reset
  svg
  path,
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu
  .typography-section
  .btn-reset
  svg
  path {
  fill: #2c6ecb;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu
  .color-form
  .btn-reset:hover,
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu
  .typography-section
  .btn-reset:hover {
  background-color: #f6f6f7;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu
  .color-form
  .__react_component_tooltip {
  box-shadow: 0px 2px 10px 0px #0000001a, 0px 0px 2px 0px #00000033;
  max-width: 25rem;
  padding: 4px 8px;
  opacity: 1;
  border-radius: 4px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu
  .menu-title
  .__react_component_tooltip::after,
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu
  .menu-title
  .__react_component_tooltip::before,
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-sidebar
  .__react_component_tooltip::after,
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-sidebar
  .__react_component_tooltip::before,
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper
  .radio-button-2
  .__react_component_tooltip::after,
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper
  .radio-button-2
  .__react_component_tooltip::before,
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu
  .color-form
  .__react_component_tooltip::after,
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu
  .color-form
  .__react_component_tooltip::before {
  display: none;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper.radio-button-wrapper--large {
  column-gap: 6px;
  row-gap: 10px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper.radio-button-wrapper--medium {
  column-gap: 7px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper.radio-button-wrapper--large
  .radio-button-2 {
  flex-basis: 130px;
  height: 48px;
  position: relative;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper.radio-button-wrapper--large
  .radio-button-2
  .check {
  position: absolute;
  top: -6px;
  right: -6px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper.radio-button-wrapper--medium
  .radio-button-2 {
  width: 84px;
  height: 48px;
  flex-grow: unset;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper.radio-button-wrapper--large
  .radio-button-2
  .Polaris-Button,
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper.radio-button-wrapper--medium
  .radio-button-2
  .Polaris-Button {
  height: 100%;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper.radio-button-wrapper--large
  .radio-button-2
  .Polaris-Button__Content {
  font-size: 18px;
  font-weight: 500;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper.radio-button-wrapper--large
  .radio-button-2
  .Polaris-Button__Content
  s {
  font-size: 12px;
  font-weight: 400;
  color: #7a7a7a;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper.radio-button-wrapper--large
  .radio-button-2
  .Polaris-Button.checked
  .Polaris-Button__Content
  s {
  color: #fff;
}
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper.radio-button-wrapper--large.radio-button-wrapper--outline
  .radio-button-2
  .Polaris-Button.checked
  .Polaris-Button__Content
  s {
  color: #7a7a7a;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper.radio-button-wrapper--large
  .radio-button-2
  .Polaris-Button.full-size
  .Polaris-Icon {
  width: 100%;
  height: 100%;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper.radio-button-wrapper--medium
  .radio-button-2
  .Polaris-Button
  .Polaris-Icon {
  width: 52px;
  height: 16px;
}

.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-settings {
  position: relative;
}

.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-settings .inner {
  overflow: auto;
  height: calc(100% - 127px);
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-settings
  .theme-setting-menu-divider-section {
  padding: 12px 20px;
  background: #f1f2f3;
  border-top: 1px solid #e1e3e5;
  border-bottom: 1px solid #e1e3e5;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-settings
  .theme-setting-menu-divider-section
  .divider-title {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-settings
  .theme-setting-menu-divider-section
  .Polaris-Icon {
  width: 14px;
  height: 14px;
  margin-left: 4px;
}

.shopify-integration-setting-visual-editor .visual-editor-body .reset-wrapper {
  padding: 1rem;
  position: absolute;
  bottom: 56px;
  width: 100%;
  box-shadow: inset 0px 1px 0px #e4e5e7;
}

.shopify-integration-setting-visual-editor .visual-editor-body .reset-wrapper button {
  white-space: nowrap;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-settings
  .menu-section {
  border-bottom: 1px solid #e1e3e5;
  padding: 8px 20px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-settings
  .menu-section:last-child {
  box-shadow: unset;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-settings
  .menu-section
  p {
  color: #6d7175;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  margin-top: 2px;
  margin-bottom: 1px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-left-panel-container
  .choose-layout-wrapper {
  padding: 16px;
  background-color: #fafbfb;
  border: 1px solid #e1e3e5;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-left-panel-container
  .choose-layout-wrapper__layout {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-left-panel-container
  .choose-layout-wrapper
  .Polaris-Button {
  width: 100%;
}

.shopify-integration-setting-visual-editor .visual-editor-body .list-layout-container {
  position: fixed;
  z-index: 99;
  box-shadow: 0px 0px 1px 0px #00000040, 0px 2px 1px 0px #0000000d;
  background-color: #fff;
  width: 200px;
  height: 100%;
  top: 0;
  left: 351px;
  padding: 12px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .list-layout-container
  .layout-sample {
  position: relative;
  width: 95%;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .list-layout-container
  .layout-sample
  .check {
  position: absolute;
  top: -5px;
  right: -6px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .list-layout-container
  .layout-sample
  img {
  width: 100%;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .list-layout-container
  .layout-sample.active
  img {
  outline: 2px solid #005e46;
  outline-offset: -2px;
  border-radius: 6px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .list-layout-container
  .layout-sample
  .premium-upgrade-link {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  text-align: center;
  white-space: nowrap;
  margin-top: -3.5px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .list-layout-container
  .layout-sample
  .premium-upgrade-link
  p {
  font-size: 14px;
  color: #2c6ecb;
}

.shopify-integration-setting-visual-editor .visual-editor-body .list-layout-container__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .list-layout-container__header
  .title {
  font-weight: 600;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .list-layout-container__header
  .Polaris-Icon__Svg
  path {
  fill: #5c5f62;
}

.shopify-integration-setting-visual-editor .visual-editor-body .list-layout-container__body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 12px;
  overflow: auto;
  height: calc(100% - 34px);
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .list-layout-container__body
  .Polaris-Choice__Control {
  visibility: hidden;
  width: 0;
  margin: 0;
  margin-top: 6px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .list-layout-container__body
  .Polaris-Choice__Descriptions {
  padding-left: 0;
}

.widget-layout-settings > div:not(:first-child),
.widget-title-settings > div:not(:first-child) {
  padding-top: 16px;
}

.widget-layout-settings div ul li {
  padding-top: 12px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-settings.title-bold-normal {
  height: 56px;
  display: flex;
  align-items: center !important;
}

.shopify-integration-setting-visual-editor .visual-editor-header .select-theme-preview {
  display: inline-flex;
  align-items: center;
  width: 100%;
}

.shopify-integration-setting-visual-editor
  .visual-editor-header
  .select-theme-preview
  > div:first-child {
  flex-grow: 1;
}

.shopify-integration-setting-visual-editor .visual-editor-header .Polaris-Tabs__Wrapper {
  border-bottom-color: transparent;
}

.shopify-integration-setting-visual-editor
  .visual-editor-header
  .Polaris-Tabs__Tab
  .Polaris-Tabs__Title::before {
  bottom: -9px;
  border-radius: 0;
  height: 2px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-header
  .Polaris-Tabs__Tab--selected
  .Polaris-Tabs__Title::before {
  background: #44474a;
}

.shopify-integration-setting-visual-editor
  .visual-editor-header
  .Polaris-Tabs__Tab--selected
  .Polaris-Icon__Svg {
  fill: #44474a;
}

.shopify-integration-setting-visual-editor .visual-editor-header .theme-preview {
  width: 493px;
  height: 100%;
  display: flex;
  align-items: center;
  margin-left: -160px;
}

.shopify-integration-setting-visual-editor .visual-editor-header .theme-preview.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.shopify-integration-setting-visual-editor
  .visual-editor-header
  .theme-preview
  .theme-preview-label {
  margin-right: 20px;
  /* margin-left: 20px; */
}

.shopify-integration-setting-visual-editor
  .visual-editor-header
  .theme-preview
  .theme-preview-label
  span {
  margin-top: 10px;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
}

.shopify-integration-setting-visual-editor .visual-editor-header .Polaris-Tabs {
  margin-left: 20px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-header
  .Polaris-Tabs__DisclosureActivator {
  display: none;
}

.shopify-integration-setting-visual-editor .visual-editor-right-panel-container .title-section {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 0;
  padding: 18px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.shopify-integration-setting-visual-editor
  .visual-editor-right-panel-container
  .title-section
  .btn-collapse {
  cursor: pointer;
}

.shopify-integration-setting-visual-editor
  .visual-editor-right-panel-container
  .title-section
  .Polaris-Icon {
  margin: 0;
}

.shopify-integration-setting-visual-editor .visual-editor-right-panel .description-panel {
  color: #6d7175;
  margin-top: 1rem;
}

.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-right-panel__remove {
  position: absolute;
  bottom: 56px;
  left: 0;
  display: flex;
  padding: 16px;
  box-shadow: inset 0px 1px 0px #e4e5e7;
  width: 100%;
  cursor: pointer;
  font-weight: 600;
  color: #6d7175;
  background: #fff;
  z-index: 999;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__remove
  .Polaris-Icon {
  margin: 0;
  margin-right: 4px;
}

.visual-editor-right-panel .Polaris-Tooltip-TooltipOverlay {
  max-width: 254px;
}

.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-settings .title {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  padding: 18px 16px;
  border-bottom: 1px solid #e1e3e5;
}

.shopify-integration-setting-visual-editor .visual-editor-settings .theme-setting-menu-item {
  border-bottom: 1px solid #e1e3e5;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item.borderless {
  box-shadow: none;
  border-bottom: none;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item:last-child {
  box-shadow: none;
  border-bottom: none;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.not-collapsible {
  padding-left: 41px;
}

.shopify-integration-setting-visual-editor .visual-editor-settings .ReactCollapse--collapse {
  padding-left: 16px;
  padding-right: 16px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .ReactCollapse--collapse {
  padding: 0;
  margin-left: 40px;
  margin-right: 8px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item.has-submenu
  .ReactCollapse--collapse {
  margin-left: 40px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item.has-submenu
  .ReactCollapse--collapse
  .ReactCollapse--collapse {
  margin-left: 26px;
  margin-right: 0;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper {
  display: flex;
  align-items: center;
  padding: 0 16px;
  transition: 0.3s all ease-in-out;
  cursor: pointer;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper
  .title-inner {
  display: flex;
  align-items: center;
  padding: 8px 0;
  width: 100%;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item.has-submenu
  .title-wrapper {
  padding-right: 0;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item.has-submenu
  .title-wrapper
  > .title-inner {
  padding-right: 16px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item.has-submenu
  .ReactCollapse--collapse
  .title-wrapper {
  padding-left: 4px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.active {
  background: #f1f8f5;
  color: #008060;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.active
  .Polaris-Icon__Svg {
  fill: #008060;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.active
  .Polaris-Icon__Svg
  path {
  fill: #008060;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.active.disabled
  .Polaris-Icon__Svg
  path {
  fill: #8c9196 !important;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper
  > .btn-view-by-page {
  margin-left: auto;
  margin-right: 28px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.not-collapsible {
  padding: 0;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.not-collapsible
  .title-inner {
  padding-left: 41px;
  padding-right: 16px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.active {
  background: #f1f8f5;
  color: #008060;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.active
  .Polaris-Icon__Svg {
  fill: #008060;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.disabled {
  color: #8c9196 !important;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.disabled
  .Polaris-Icon__Svg {
  fill: #8c9196 !important;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.disabled
  ~ .ReactCollapse--collapse
  .theme-setting-menu-children:not(.btn-add) {
  color: #8c9196 !important;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.disabled
  ~ .ReactCollapse--collapse
  .theme-setting-menu-children:not(.btn-add)
  .Polaris-Icon__Svg
  path {
  fill: var(--p-icon);
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.disabled
  ~ .ReactCollapse--collapse
  .theme-setting-menu-children.disabled:not(.btn-add)
  .Polaris-Icon__Svg
  path {
  fill: #8c9196 !important;
}

.shopify-integration-setting-visual-editor .visual-editor-settings .theme-setting-menu-children,
#draggable .theme-setting-menu-children {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  transition: 0.3s background ease-in-out;
  border-radius: 4px;
  cursor: pointer;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children.area {
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  justify-content: flex-start;
}

.shopify-integration-setting-visual-editor .visual-editor-settings .theme-setting-menu-droppable {
  min-height: 4px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children.active,
#draggable .theme-setting-menu-children.active {
  background: #f1f8f5;
  color: #008060;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children.active
  .Polaris-Icon__Svg
  rect,
#draggable .theme-setting-menu-children.active .Polaris-Icon__Svg rect {
  fill: #008060;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children
  .Polaris-Icon {
  margin: 0;
  margin-right: 8px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children__action
  .Polaris-Icon {
  margin: 0;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children.disabled,
#draggable .theme-setting-menu-children.disabled {
  color: #8c9196 !important;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children.disabled
  .Polaris-Icon
  svg,
#draggable .theme-setting-menu-children.disabled .Polaris-Icon svg {
  fill: #8c9196 !important;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children.disabled
  .btn-drag
  .Polaris-Icon
  svg,
#draggable .theme-setting-menu-children.disabled .btn-drag .Polaris-Icon svg {
  fill: var(--p-icon) !important;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children.active
  .Polaris-Icon
  svg,
#draggable .theme-setting-menu-children.active .Polaris-Icon svg {
  fill: #008060 !important;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children.active
  .btn-drag
  .Polaris-Icon
  svg,
#draggable .theme-setting-menu-children.active .btn-drag .Polaris-Icon svg {
  fill: #008060 !important;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children.active.disabled
  .btn-view
  .Polaris-Icon
  svg,
#draggable .theme-setting-menu-children.active.disabled .btn-view .Polaris-Icon svg {
  fill: #8c9196 !important;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.disabled
  .btn-view-by-page,
.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children.disabled
  .btn-view,
#draggable .theme-setting-menu-children.disabled .btn-view {
  opacity: 1;
  visibility: visible;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children.btn-add {
  color: #2c6ecb;
  justify-content: flex-start;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children.btn-add
  .Polaris-Icon {
  display: flex;
  align-items: center;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children.btn-add
  .Polaris-Icon
  svg {
  fill: #2c6ecb;
  width: 16px;
  height: 16px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children.btn-add.disabled {
  pointer-events: none !important;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children__action,
#draggable .theme-setting-menu-children .theme-setting-menu-children__action {
  display: flex;
  align-items: center;
  column-gap: 8px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .btn-view-by-page,
.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children__action
  .btn-view,
.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children__action
  .btn-drag,
.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children__action
  .btn-remove {
  visibility: hidden;
  opacity: 0;
  transition: 0.2s all;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children
  .theme-setting-menu-children__action.show
  .btn-view,
.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children
  .theme-setting-menu-children__action.show
  .btn-drag,
.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children
  .theme-setting-menu-children__action.show
  .btn-remove,
#draggable .theme-setting-menu-children .theme-setting-menu-children__action.show .btn-view,
#draggable .theme-setting-menu-children .theme-setting-menu-children__action.show .btn-drag,
#draggable .theme-setting-menu-children .theme-setting-menu-children__action.show .btn-remove {
  opacity: 1;
  visibility: visible;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper:hover
  .btn-view-by-page,
.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children:hover
  .theme-setting-menu-children__action
  .btn-view,
.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children:hover
  .theme-setting-menu-children__action
  .btn-drag,
.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children:hover
  .theme-setting-menu-children__action
  .btn-remove,
#draggable .theme-setting-menu-children:hover .theme-setting-menu-children__action .btn-view,
#draggable .theme-setting-menu-children:hover .theme-setting-menu-children__action .btn-drag,
#draggable .theme-setting-menu-children:hover .theme-setting-menu-children__action .btn-remove {
  opacity: 1;
  visibility: visible;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper:hover,
.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children:hover,
#draggable .theme-setting-menu-children:hover {
  background: #f6f6f7;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.active:hover,
.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children.active:hover,
#draggable .theme-setting-menu-children.active:hover {
  background: #f1f8f5;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children
  > span,
#draggable .theme-setting-menu-children > span {
  display: block;
  max-width: 125px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper
  .caret {
  padding: 8px 0;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper
  .caret {
  margin-right: 5px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper
  .caret
  .Polaris-Icon {
  transition: 0.2s all ease-in-out;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper
  .caret.closed
  .Polaris-Icon {
  transform: rotate(-90deg);
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper
  .menu-title {
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper
  .menu-icon {
  margin-right: 8px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper
  .menu-icon
  svg,
.shopify-integration-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children.area
  .menu-icon
  svg {
  width: 18px;
  height: 18px;
}

.theme-setting-menu-children__menu-add {
  padding: 8px 0;
  min-width: 220px;
}

.theme-setting-menu-children__menu-add .Polaris-ActionList__Title {
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: #6d7175;
  padding: 8px 16px;
  text-transform: uppercase;
}

.theme-setting-menu-children__menu-add .Polaris-ActionList__Actions {
  padding: 0;
}

.theme-setting-menu-children__menu-add .Polaris-ActionList__Item {
  padding: 8px 16px;
  border-radius: 0;
  width: 219px;
}

.theme-setting-menu-children__menu-add .Polaris-ActionList__Item:hover {
  color: #008060;
  background: #f1f8f5;
}

.draggable-zone.dragging {
  border-radius: 8px;
  border: 1px dashed var(--interactive);
}

.draggable-zone.draggable-zone--margin-left {
  margin-left: 18px;
}

.draggable-zone.dragging.draggable-zone--margin-left {
  margin-right: 8px;
}

/* Ajax cart */
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview
  .visual-editor-preview__overlay
  .ajax-cart {
  display: flex;
  flex-direction: column;
  position: fixed;
  background: #ffffff;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview
  .visual-editor-preview__overlay
  .ajax-cart--popup {
  top: 50%;
  left: calc(58% - 352px);
  transform: translate(0, -50%);
  width: 732px;
  max-height: min(640px, calc(100% - 60px - 60px));
}

@media screen and (max-width: 1280px) {
  .shopify-integration-setting-visual-editor
    .visual-editor-body
    .visual-editor-preview
    .visual-editor-preview__overlay
    .ajax-cart--popup {
    left: calc(62% - 352px);
  }
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview
  .visual-editor-preview__overlay
  .boost-sd__cart--side {
  height: calc(100% - 56px);
  top: 56px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview
  .visual-editor-preview__overlay.popup
  .boost-sd__modal-container {
  left: calc(52% - 352px);
  top: 50%;
  transform: translate(0, -50%);
  position: absolute;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview.full
  .visual-editor-preview__overlay.popup
  .boost-sd__modal-container {
  left: 50%;
  transform: translate(-50%, -50%);
}

/* ----- Ajax cart */

.btn-group-polaris .Polaris-ButtonGroup__Item {
  margin-left: 10px;
}

/* Preview theme setting overwrite css */
.boost-sd__filter-option-content-inner,
.boost-sd__sorting-button,
/* .boost-sd__pagination, */
.boost-sd__search-form-input,
.boost-sd__search-form .boost-sd__button,
.boost-sd__filter-tree-toggle-button {
  pointer-events: none;
}

.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-sidebar {
  display: flex;
  width: 52px;
  height: 100%;
  padding: 6px 0px;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  border-right: 1px solid #e1e3e5;
  background: #fff;
}

.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-sidebar__item {
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-sidebar__item
  .Polaris-Icon {
  margin: 0;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-sidebar__item
  .Polaris-Icon__Svg {
  width: 20px;
  height: 20px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-sidebar__item
  .Polaris-Icon--custom.Polaris-Icon--colorPrimary
  .Polaris-Icon__Svg
  path {
  fill: var(--p-action-primary);
}

.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-sidebar__item:hover,
.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-sidebar__item.active {
  background: #f1f2f3;
}

.BC-ThemeSetting-Editor-Page.shopify-integration-setting-visual-editor
  ~ #PolarisPortalsContainer
  .Polaris-PositionedOverlay {
  z-index: 520;
}

.BC-ThemeSetting-Editor-Page.shopify-integration-setting-visual-editor
  ~ #PolarisPortalsContainer
  .Polaris-Modal-Dialog--sizeLarge.Polaris-Modal-Dialog--fullScreen {
  max-width: 1164px;
  height: calc(100vh - 3.75rem);
}

.BC-ThemeSetting-Editor-Page.shopify-integration-setting-visual-editor
  ~ #PolarisPortalsContainer
  .Polaris-Modal-Dialog--sizeLarge.Polaris-Modal-Dialog--fullScreen
  .Polaris-Modal__Body
  > .Polaris-Modal-Section {
  height: 100%;
  padding: 0;
}

/* New theme setting */

/* Global styles */
.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-menu {
  width: 300px;
  height: 100%;
  background: #ffffff;
  border-right: 1px solid #e1e3e5;
  overflow: auto;
}

.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-menu-developer {
  width: 300px;
  height: 100%;
  background: #ffffff;
  border-right: 1px solid #e1e3e5;
}

/* .shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-menu.opened {
  transform: translate(0, 0);
} */

.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-menu .title-wrapper {
  border-bottom: 1px solid #e1e3e5;
}

.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-menu .menu-title h2 {
  display: flex;
  align-items: center;
}

.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-menu .menu-title,
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu-developer
  .menu-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  height: 48px;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
}

.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-menu .menu-title h2 {
  font-weight: 600;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu-developer
  .menu-title {
  border-bottom: 1px solid #e1e3e5;
}

.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-menu .tooltip-icon {
  display: flex;
  margin-left: 6px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu
  .tooltip-icon
  #menu-question {
  min-width: 130px;
}

.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-menu .product-guide {
  padding: 0 16px;
  padding-bottom: 17px;
}

.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-menu .form-link {
  color: #2c6ecb;
  align-items: center;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu
  .form-link
  a:visited {
  color: #2c6ecb;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu
  .form-link
  .Polaris-Icon {
  margin: 0;
  margin-left: 2px;
  display: inline-block;
  position: relative;
  top: 2.5px;
  width: 15px;
  height: 15px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu
  .form-link
  .Polaris-Icon
  svg {
  fill: #2c6ecb;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu
  .form-link.form-link--normal
  .Polaris-Icon
  svg {
  fill: #5c5f62;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu
  .form-link.form-link--normal
  .Polaris-Icon {
  top: 1px;
  margin-left: 0;
  width: 14px;
  height: 14px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu
  .menu-title
  .btn-back {
  cursor: pointer;
  margin-right: 8px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu
  .menu-title
  .btn-back
  .Polaris-Icon {
  width: 16px;
  height: 16px;
}

.visual-editor-menu
  .menu-container.menu-container--no-border-bottom
  .menu-container__item:last-child {
  border-bottom: 0 !important;
}

.visual-editor-menu .menu-container .menu-container__item {
  display: flex;
  padding: 0 12px 0 16px;
  height: 40px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e1e3e5;
  cursor: pointer;
}

.visual-editor-menu .menu-container.disabled .menu-container__item,
.visual-editor-menu .menu-container .menu-container__item.disabled {
  cursor: default;
  pointer-events: none;
}

.visual-editor-menu .menu-container.disabled .menu-container__item .menu-container__item__name,
.visual-editor-menu .menu-container .menu-container__item.disabled .menu-container__item__name {
  opacity: 0.5;
}

.visual-editor-menu .menu-container.disabled .menu-container__item > .Polaris-Icon,
.visual-editor-menu .menu-container .menu-container__item.disabled > .Polaris-Icon {
  opacity: 0.5;
}

.visual-editor-menu .menu-container .menu-container__item.menu-container__item--start {
  height: 68px;
  align-items: flex-start;
  padding-top: 6px;
  padding-left: 6px;
  padding-right: 6px;
}

.visual-editor-menu .menu-container .menu-container__item .Polaris-Icon {
  margin-right: 0;
}

.visual-editor-menu .menu-container .menu-container__item:hover {
  background-color: #f1f1f1;
}

.visual-editor-menu .menu-container .menu-container__item .menu-container__item__name {
  display: flex;
  gap: 8px;
  align-items: center;
  font-weight: 600;
}

.visual-editor-menu
  .menu-container
  .menu-container__item
  .menu-container__item__name.menu-container__item__name--column {
  flex-direction: column;
  align-items: flex-start;
}

.visual-editor-menu .menu-container .menu-container__item .Polaris-Icon {
  margin: 0;
}

.visual-editor-menu .menu-container .menu-container__item > .Polaris-Icon {
  width: 14px;
  height: 14px;
}

.visual-editor-menu
  .menu-container
  .menu-container__item
  .menu-container__item__name
  > .Polaris-Icon {
  width: 16px;
  height: 16px;
}

.visual-editor-menu .menu-global-styles-section {
  padding: 16px;
}

.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-menu .form-container {
  padding: 16px;
  padding-top: 0;
  height: calc(100% - 49px);
  overflow: auto;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu.with-reset
  .form-container {
  height: calc(100% - 102px);
}

/* Global styles */

/* Colors */

.shopify-integration-setting-visual-editor .form-container .color-picker-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.shopify-integration-setting-visual-editor
  .form-container
  .color-picker-container.color-picker-container--column {
  flex-direction: column;
}

.shopify-integration-setting-visual-editor
  .form-container
  .color-picker-container
  .color-picker-item.color-picker-item--rectangle {
  flex-grow: 1;
  flex-basis: 0;
}

.shopify-integration-setting-visual-editor
  .form-container
  .color-picker-container
  .color-picker-item.color-picker-item--rectangle
  .color-picker-item__box-color {
  height: 36px;
  width: 100%;
  border: 1px solid #e1e3e5;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  text-transform: uppercase;
  cursor: pointer;
}

.shopify-integration-setting-visual-editor
  .form-container
  .color-picker-container
  .color-picker-item.color-picker-item--rectangle
  .color-picker-item__box-color
  .color-picker-item__value {
  pointer-events: none;
  margin-left: 6px;
  font-size: 12px;
}

.shopify-integration-setting-visual-editor
  .form-container
  .color-picker-container
  .color-picker-item.color-picker-item--rectangle
  .color-picker-item__box-color
  path {
  fill: inherit;
}

.shopify-integration-setting-visual-editor
  .form-container
  .color-picker-container
  .color-picker-item.color-picker-item--circle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.shopify-integration-setting-visual-editor
  .form-container
  .color-picker-container
  .color-picker-item.color-picker-item--circle.not-connected-palette
  > div:nth-child(3),
.shopify-integration-setting-visual-editor
  .form-container
  .color-picker-container
  .color-picker-item.color-picker-item--circle.connected-palette
  > div:nth-child(2) {
  display: none;
}

.shopify-integration-setting-visual-editor
  .form-container
  .color-picker-container
  .color-picker-item.color-picker-item--circle
  .color-picker-item__box-color {
  border-radius: 50%;
  width: 32px;
  height: 32px;
  border: 1px solid #c9cccf;
}

.shopify-integration-setting-visual-editor
  .form-container
  .color-picker-container
  .color-picker-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.shopify-integration-setting-visual-editor
  .form-container
  .color-picker-container
  .color-picker-info
  .color-picker-item__name {
  font-weight: 500;
  margin-bottom: 2px;
}

.shopify-integration-setting-visual-editor
  .form-container
  .color-picker-container
  .color-picker-info
  .color-picker-item__value {
  font-size: 12px;
}

.shopify-integration-setting-visual-editor
  .form-container
  .color-picker-container
  .color-picker-info
  .color-picker-item__value.color-picker-item__value--hex {
  text-transform: uppercase;
}

.shopify-integration-setting-visual-editor .form-container .color-palette {
  display: flex;
  margin-top: 10px;
}

.shopify-integration-setting-visual-editor .form-container .color-palette-item {
  height: 14px;
  flex-grow: 1;
  cursor: pointer;
}

.shopify-integration-setting-visual-editor .form-container .color-palette-item:hover {
  box-shadow: 0px 0px 3.5px 2.25px rgba(0, 0, 0, 0.39);
  outline: 2px solid #fff;
  z-index: 10;
  /* outline-offset: 2px; */
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .color-palette
  .__react_component_tooltip {
  box-shadow: 0px 2px 10px 0px #0000001a, 0px 0px 2px 0px #00000033;
  max-width: 25rem;
  padding: 4px 8px;
  opacity: 1;
  border-radius: 4px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu
  .color-palette
  .__react_component_tooltip::after,
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu
  .color-palette
  .__react_component_tooltip::before {
  display: none;
}

.shopify-integration-setting-visual-editor
  .form-container
  .color-picker-item
  .color-picker-item__empty {
  height: 36px;
  width: 100%;
  border: 1px dashed #8c9196;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  cursor: pointer;
  background-color: white;
}

.shopify-integration-setting-visual-editor
  .form-container
  .color-picker-item
  .color-picker-item__empty:hover {
  background-color: #f6f6f7;
}

.shopify-integration-setting-visual-editor
  .form-container
  .color-picker-item
  .color-picker-item__empty
  .Polaris-Icon {
  width: 16px;
  height: 16px;
}

.shopify-integration-setting-visual-editor .form-container .banner-warning-contrast {
  margin-top: 16px;
}

.shopify-integration-setting-visual-editor
  .form-container
  .color-picker-item
  .color-picker-item__activator {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  width: 20px;
  border-radius: 4px;
  cursor: pointer;
}

.shopify-integration-setting-visual-editor
  .form-container
  .color-picker-item
  .color-picker-item__activator:hover {
  background-color: #f6f6f7;
}

.shopify-integration-setting-visual-editor
  .form-container
  .color-picker-item
  .color-picker-item__activator:hover
  path {
  fill: #000;
}

.shopify-integration-setting-visual-editor
  .form-container
  .color-picker-item
  .color-picker-item__activator.color-picker-item__activator--active
  path {
  fill: #007f5f;
}

.visual-editor-menu
  .menu-container
  .menu-container__item
  .menu-container__item__name
  .advanced-color
  .Polaris-Icon {
  width: 16px;
  height: 16px;
}

.visual-editor-menu
  .menu-container
  .menu-container__item
  .menu-container__item__name
  .advanced-color
  .Polaris-Icon__Svg {
  fill: #5c5f62;
}

.color-palette-picker {
  width: 264px;
  min-height: 192px;
  border-radius: 8px;
  padding: 8px 0 16px;
}

.color-palette-picker .color-palette-picker__header {
  padding: 8px 16px;
}

.color-palette-picker .color-palette-picker__header .title {
  font-weight: 600;
  font-size: 12px;
  color: #6d7175;
}

.color-palette-picker .color-palette-picker__subheader {
  padding: 10px 16px;
  border-top: 1px solid #e4e5e7;
}

.color-palette-picker .color-palette-picker__subheader .title {
  font-weight: 600;
}

.color-palette-picker .color-palette-picker__body {
  padding: 0 16px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.color-palette-picker .color-palette-picker__body .color-palette-picker-item {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #c9cccf;
  cursor: pointer;
}

.color-palette-picker .color-palette-picker__body .color-palette-picker-item:hover,
.color-palette-picker .color-palette-picker__body .color-palette-picker-item.active {
  outline: 2px solid #c9cccf;
  outline-offset: 2px;
}

.color-palette-picker .color-palette-picker__body .__react_component_tooltip {
  box-shadow: 0px 2px 10px 0px #0000001a, 0px 0px 2px 0px #00000033;
  max-width: 25rem;
  padding: 4px 8px;
  opacity: 1;
  border-radius: 4px;
  font-size: 12px;
}

.color-palette-picker .color-palette-picker__body .__react_component_tooltip::after,
.color-palette-picker .color-palette-picker__body .__react_component_tooltip::before {
  display: none;
}

#color-picker-connect {
  white-space: nowrap;
  padding: 4px 8px;
  border-radius: 4px;
  box-shadow: 0px 2px 10px 0px #0000001a, 0px 0px 2px 0px #00000033;
  opacity: 1;
}

#color-picker-connect::after,
#color-picker-connect::before {
  display: none;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .form-container
  .form-section__item__title-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

#color-contrast {
  width: 260px;
}

/* Colors */

/* Typography */
.visual-editor-menu
  .menu-container
  .menu-container__item
  .menu-container__item__name
  .typography-section {
  font-weight: 600;
}

.visual-editor-menu
  .menu-container
  .menu-container__item
  .menu-container__item__name
  .typography-value {
  font-weight: 400;
  font-size: 12px;
}

.shopify-integration-setting-visual-editor
  .form-container
  .typography-form
  .BC-Select__menu
  .BC-Select__menu-list
  .BC-Select__group:first-child {
  border-bottom: 1px solid #e1e3e5;
  padding: 8px;
  padding-bottom: 12px;
  margin: 0 -8px;
}

.shopify-integration-setting-visual-editor
  .form-container
  .typography-form
  .Polaris-TextField__Spinner {
  display: none;
}

/* Typography */

/* Menu developer */
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu-developer
  .menu-container {
  padding: 8px;
  height: calc(100vh - 104px);
}

.shopify-integration-setting-visual-editor
  .visual-editor-body.warning
  .visual-editor-menu-developer
  .menu-container {
  height: calc(100vh - 152px);
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu-developer
  .menu-container
  .menu-container__search {
  margin-bottom: 22px;
}

.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-code {
  width: calc(100% - 300px);
  height: calc(100vh - 56px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 42px;
}

.shopify-integration-setting-visual-editor .visual-editor-body.warning .visual-editor-code {
  height: calc(100vh - 104px);
}


.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__empty {
  text-align: center;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__empty
  .title {
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  margin-bottom: 6px;
  margin-top: 24px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container {
  width: 100%;
  height: 100%;
  box-shadow: 0px 0px 1px 0px #00000040, 0px 2px 1px 0px #0000000d;
  background-color: #ffffff;
  border-radius: 8px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__col {
  height: 100%;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__col
  .monaco-editor-wrapper {
  height: calc(100% - 56px - 44px);
}
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__col
  .monaco-editor-wrapper.monaco-editor-wrapper--error {
  height: calc(100% - 56px - 44px - 72px);
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__files {
  display: flex;
  white-space: nowrap;
  overflow: auto;
  height: 44px;
  border-bottom: 1px solid #e1e3e5;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__file-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__file-item
  .Polaris-Button {
  border: none;
  min-width: auto;
  min-height: auto;
  height: 28px;
  width: 28px;
  padding: 0;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__file-item.editing
  .changed-spot {
  background-color: #008060;
  border-radius: 100%;
  height: 0.5rem;
  width: 0.5rem;
  display: block;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__file-item.editing
  .Polaris-Button:hover
  .changed-spot {
  display: none;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__file-item
  .Polaris-Icon {
  margin: 0;
  width: 10px;
  height: 10px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__file-item.editing
  .Polaris-Icon {
  display: none;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__file-item.editing
  .Polaris-Button:hover
  .Polaris-Icon {
  display: inline-block;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__file-item
  .Polaris-Icon
  .Polaris-Icon__Svg {
  width: 10px;
  height: 10px;
  fill: #5c5f62;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__file-item:hover {
  border-bottom: 2px solid #00806083;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__file-item.active {
  border-bottom: 2px solid #008060 !important;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__version {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__version
  .visual-editor-code__version-inner {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__version
  .visual-editor-code__version-change {
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
}
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__version
  .visual-editor-code__version-change
  .changed-spot {
  background-color: #5c5f62;
  border-radius: 100%;
  height: 0.5rem;
  width: 0.5rem;
  display: block;
  position: relative;
  top: 1px;
}
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__version
  .visual-editor-code__version-dropdown
  .Polaris-Button {
  color: rgb(32, 34, 35);
  min-height: 1.75rem;
  padding-top: 2px;
  padding-bottom: 2px;
}
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__version
  .visual-editor-code__version-dropdown
  .Polaris-Button:hover {
  background-color: #f6f6f7;
  text-decoration: none;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__version
  .visual-editor-code__version-dropdown
  .Polaris-Button
  .Polaris-Button__Text {
  display: flex;
  align-items: center;
  gap: 4px;
}
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__version
  .visual-editor-code__version-dropdown
  .Polaris-Button
  .Polaris-Icon {
  margin: 0;
}
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__version
  .visual-editor-code__version-dropdown
  .Polaris-Button
  .Polaris-Icon__Svg {
  fill: rgb(32, 34, 35);
}
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__version
  .visual-editor-code__version-dropdown
  .Polaris-Button
  .Polaris-Spinner {
  position: relative;
  top: 2px;
}
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__version
  .visual-editor-code__version-dropdown
  .Polaris-Button
  .Polaris-Spinner
  svg {
  fill: rgb(32, 34, 35);
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__error {
  background-color: #FFF4F4B2;
  padding: 14px 12px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__error 
  .visual-editor-code__error__title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
  margin-bottom: 4px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__error
  .visual-editor-code__error__content {
  padding-left: 26px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__btn-enable {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .icon-question-edit
  .Polaris-Icon {
  margin: 0;
  width: 12px;
  height: 12px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .__react_component_tooltip {
  box-shadow: 0px 2px 10px 0px #0000001a, 0px 0px 2px 0px #00000033;
  max-width: 25rem;
  padding: 4px 8px;
  opacity: 1;
  border-radius: 4px;
  font-size: 12px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .__react_component_tooltip::after,
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .__react_component_tooltip::before {
  display: none;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu-developer
  .menu-container
  div[role='tree']
  > div {
  height: 100% !important;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu-developer
  .menu-container
  .tree-item {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu-developer
  .menu-container
  .tree-item
  .Polaris-Icon {
  margin: 0;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu-developer
  .menu-container
  .tree-item-content {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  height: 100%;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu-developer
  .menu-container
  .tree-item-content.edited {
  color: #916A00;
  background-color: #FFFBF3;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu-developer
  .menu-container
  .tree-item-content.edited .Polaris-Icon__Svg {
  fill: #B98900;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu-developer
  .menu-container
  .tree-item-content.edited::before {
  content: '';
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  position: absolute;
  left: 10px;
  background-color: #B98900;
}
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu-developer
  .menu-container
  .tree-item-content.active.edited::before {
  background-color: #008060;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu-developer
  .menu-container
  .tree-item-content.active {
  color: #008060;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu-developer
  .menu-container
  .tree-item-content.active
  .Polaris-Icon__Svg {
  fill: #008060;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu-developer
  .menu-container
  .tree-item:hover
  .tree-item-content,
.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu-developer
  .menu-container
  .tree-item-content.active {
  background-color: #f6f6f7;
}

/* Menu developer */

.shopify-integration-setting-visual-editor .visual-editor-menu .source-option .source-option--flex {
  display: flex;
  align-items: center;
  gap: 4px;
}

.shopify-integration-setting-visual-editor .visual-editor-menu .source-option .source-option--link {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  margin-top: 4px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-menu
  .source-option
  .source-option--link
  .Polaris-Link {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  text-decoration: none;
  color: #2c6ecb;
}

.shopify-integration-setting-visual-editor
  .visual-editor-menu
  .source-option
  .Polaris-Badge
  > span {
  display: flex;
  align-items: center;
}

.shopify-integration-setting-visual-editor .visual-editor-menu .form-section__item--flex-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-code
  .visual-editor-code__container
  .visual-editor-code__col .btn-compare.btn-compare--active .Polaris-Button {
  background-color: #F2F7FE;
  color: #2C6ECB;
  border-color: transparent;
}

/* app wishlist integration */
.form-section__item-integrated-app {
  margin-left: 28px;
  background-color: #F6F6F7;
  border-radius: 6px;
  padding: 8px;
}

.form-section__item-integrated-app .form-title-content {
  margin-right: 6px;
  font-weight: 600;
}

.icon-app-wishlist__container {
  margin-top: 4px;
}

.icon-app-wishlist__item-app-name {
  margin-top: 0;
  flex: 1 1 0;
  min-height: 0;
} 

.icon-app-wishlist__container-empty {
  margin-top: 14px;
  color: #6D7175;
}

.icon-app-wishlist__item img {
  width: 32px;
  height: 32px;
  border-radius: 4px;
}

.icon-app-wishlist__item-config-link {
  text-decoration: underline;
}

.icon-app-wishlist__item-dot {
  color: #2c6ecb;
}
.shopify-integration-setting-visual-editor .BC-Toggle-Switch-Button .Polaris-Labelled__LabelWrapper {
  margin-left: 16px;
}

.widget-visual-editor .visual-editor-body #preview-shopify-integration-setting-cart.preview-cart--mobile {
  width: 497px !important;
  top: 54px;  
  left: 45%;
  border: 0;
  height: calc(100% - 54px);
}
.widget-visual-editor .visual-editor-body #preview-shopify-integration-setting-cart.preview-cart--mobile.preview-cart--side {
  width: 324px !important;
  left: 50%;
}

.widget-visual-editor .visual-editor-body #preview-shopify-integration-setting-cart.preview-cart--fullscreen {
  width: 100%;
  left: 0;
}

.widget-visual-editor
  .visual-editor-body
  #preview-shopify-integration-setting-cart {
  height: 100%;
  width: 324px;
  border: 0;
}

.widget-visual-editor
  .visual-editor-body
  #preview-shopify-integration-setting-cart.preview-cart--popup {
  width: 960px;
}


.widget-visual-editor
  .visual-editor-body
  .cart-drawer-preview-container 
  .visual-editor-preview {
    display: flex;
    flex-direction: column;
    margin-bottom: 0;
    height: 100%;
    margin-top: 1rem;
}

.widget-visual-editor
  .visual-editor-body
  .visual-editor-preview
  .visual-editor-preview__overlay-cart {
    flex-grow: 1;
    display: flex;
    justify-content: center;
}

.widget-visual-editor
  .visual-editor-body .visual-editor-preview .Polaris-SkeletonThumbnail {
    width: 320px;
    height: 100%;
}

.widget-visual-editor
  .visual-editor-body .visual-editor-preview  .preview-shopify-integration-setting-cart__skeleton--popup {
    margin: auto;
}

.widget-visual-editor
  .visual-editor-body .visual-editor-preview  .preview-shopify-integration-setting-cart__skeleton--popup
  .Polaris-SkeletonThumbnail {
    width: 960px;
    height: 520px;
}


.shopify-integration-setting-visual-editor .visual-editor-warning {
  background-color: #FFFBF3;
  width: 100%;
  padding: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu .cart-layout {
  margin-top: 16px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu .cart-layout > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu .cart-layout > div:first-of-type {
  margin-top: 6px;
  margin-bottom: 8px;
}

.shopify-integration-setting-visual-editor
  .visual-editor-body
  .visual-editor-menu .cart-layout .Polaris-Icon {
  margin: 0;
  width: 10px;
  height: 10px;
}`, "",{"version":3,"sources":["webpack://./src/styles/shopify-integration-settings.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,YAAY;EACZ,gEAAgE;AAClE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB;uBACqB;AACvB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;;;EAGE,eAAe;EACf,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;EAGE,YAAY;EACZ,SAAS;EACT,SAAS;EACT,SAAS;EACT,yBAAyB;AAC3B;AACA;;;EAGE,WAAW;EACX,OAAO;AACT;;AAEA;;;EAGE,YAAY;EACZ,SAAS;EACT,SAAS;EACT,SAAS;EACT,yBAAyB;AAC3B;AACA;;;EAGE,YAAY;EACZ,SAAS;AACX;AACA;;;EAGE,WAAW;EACX,OAAO;AACT;;AAEA;;;EAGE,eAAe;EACf,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,OAAO;AACT;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;;;EAIE,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,2EAA2E;EAC3E,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,eAAe;EACf,6BAA6B;EAC7B,YAAY;AACd;;AAEA;;;;EAIE,0BAA0B;AAC5B;;AAEA;;;;EAIE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,sCAAsC;EACtC;;YAEU;EACV,+BAA+B;EAC/B,YAAY;AACd;;AAEA;;;EAGE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;;;EAGE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,SAAS;EACT,QAAQ;EACR,8BAA8B;AAChC;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE,qCAAqC;EACrC,eAAe;AACjB;;AAEA;;;;;EAKE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;;;;EAME,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;;;;;;EAOE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;;;;;;EAOE,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;EAME,oBAAoB;AACtB;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;;;;;EAME,wBAAwB;AAC1B;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;;;;;EAKE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;;EAKE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;AACV;;AAEA;;;;;EAKE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;;EAKE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;;EAKE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;;;EAME,eAAe;AACjB;;AAEA;;;;;;EAME,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;;;;;;EAME,cAAc;EACd,WAAW;AACb;;AAEA;;;;;;EAME,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;;;;;;EAOE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;;;EAME,WAAW;EACX,eAAe;AACjB;;AAEA;;;;;;EAME,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,kBAAkB;EAClB,SAAS;AACX;;AAEA;;;;;;EAME,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,8BAA8B;AAChC;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,8BAA8B;AAChC;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;;;;;;EAME,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;;EAKE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;;;EAME,gBAAgB;AAClB;;AAEA;;;;;EAKE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;;;;;EAQE,kCAAkC;AACpC;;AAEA;;;;;;;;EAQE,iCAAiC;AACnC;;AAEA;;;;;;;EAOE,eAAe;AACjB;;AAEA;;;;;;EAME,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;;;;EAME,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;;;EAKE,SAAS;EACT,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;;;;;EAKE,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qFAAqF;EACrF,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;;;EAGE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;;;;EAKE,UAAU;EACV,kBAAkB;AACpB;;AAEA;;;;;EAKE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;;;EAKE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,6BAA6B;AAC/B;;AAEA;;;;;;;EAOE,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;;;;;EAME,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;;;;EAOE,uBAAuB;AACzB;;AAEA;;;;;;;EAOE,eAAe;AACjB;;AAEA;;;;EAIE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;;;;;;;;EAQE,WAAW;EACX,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,MAAM;EACN,OAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;;EAIE,WAAW;EACX,qBAAqB;AACvB;;AAEA;;;;;EAKE,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;;;EAIE,eAAe;EACf,0CAA0C;AAC5C;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,eAAe;AACjB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;;;EAKE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;EAIE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;;;;EAKE,YAAY;AACd;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;;;;;EAKE,eAAe;EACf,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;;;;EAKE,cAAc;EACd,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;;;;;EAKE,2EAA2E;AAC7E;;AAEA;;;;;EAKE,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;EAcE,aAAa;AACf;;AAEA;;;;;;EAME,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;;;;;;;;;EASE,iEAAiE;EACjE,gBAAgB;EAChB,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;;;;;EAKE,iEAAiE;EACjE,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;;;;;EAKE,kBAAkB;EAClB,YAAY;AACd;;AAEA;;;;;;EAME,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,wBAAwB;EACxB,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;;;;;;;;;;;;EAYE,WAAW;AACb;;AAEA;;;;;;;;;;;;;;EAcE,aAAa;AACf;;AAEA;;;;;;;;;;EAUE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,iEAAiE;EACjE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsCE,aAAa;AACf;;AAEA;;;EAGE,eAAe;EACf,aAAa;AACf;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;;;;EAIE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;;;EAKE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;;;;EAIE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;;;;;;;;EAUE,YAAY;AACd;;AAEA;;;;;EAKE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;;EAME,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;;;EAOE,WAAW;AACb;AACA;;;;;;;EAOE,cAAc;AAChB;;AAEA;;;;;;EAME,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;EAME,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;;;EAIE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;;;;;EAKE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;;;;EAKE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;;;;;EAKE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;;EAIE,aAAa;EACb,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gEAAgE;EAChE,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,MAAM;EACN,WAAW;EACX,aAAa;AACf;;AAEA;;;;EAIE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;;;;EAKE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;;;;;EAKE,0BAA0B;EAC1B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;;;;EAKE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;;;EAME,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;;;EAIE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;AACjB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,YAAY;EACZ,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;;EAIE,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;;;EAIE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;;;;;EAKE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;;;EAIE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,aAAa;EACb,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;;;;EAIE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;EAGE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;EAGE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;EAIE,UAAU;EACV,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;;;;;EAKE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA;;;;;EAKE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;;;;;EAKE,mBAAmB;AACrB;;AAEA;;;;;EAKE,iBAAiB;AACnB;;AAEA;;;;EAIE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;;;;;;EAME,wBAAwB;AAC1B;;AAEA;;;;;EAKE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;;;;;EAKE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;EAIE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,wBAAwB;AAC1B;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,mBAAmB;AACrB;;AAEA;;;;;;;;EAQE,wBAAwB;AAC1B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;EAGE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;EAIE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;;;;EAIE,SAAS;EACT,iBAAiB;AACnB;;AAEA;;;;EAIE,SAAS;AACX;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,wBAAwB;AAC1B;;AAEA;;;;;;;EAOE,8BAA8B;AAChC;;AAEA;;;;;;EAME,wBAAwB;AAC1B;;AAEA;;;;;;;EAOE,wBAAwB;AAC1B;;AAEA;;;;;;;EAOE,wBAAwB;AAC1B;;AAEA;;;;;;;;;;EAUE,UAAU;EACV,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;;EAKE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,+BAA+B;AACjC;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;;;;;;;;;;;;;;EAgBE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,UAAU;EACV,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;EAuBE,UAAU;EACV,mBAAmB;AACrB;;AAEA;;;;;;;;EAQE,mBAAmB;AACrB;;AAEA;;;;;;;;EAQE,mBAAmB;AACrB;;AAEA;;;;;EAKE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;;;EAKE,iBAAiB;AACnB;;AAEA;;;;;;EAME,gCAAgC;AAClC;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;;;;EAKE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;;EAKE,iBAAiB;AACnB;;AAEA;;;;;;;;;;;EAWE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,cAAc;AACd;;;;;EAKE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;;;EAKE,QAAQ;EACR,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE;;;;;IAKE,uBAAuB;EACzB;AACF;;AAEA;;;;;EAKE,yBAAyB;EACzB,SAAS;AACX;;AAEA;;;;;EAKE,uBAAuB;EACvB,QAAQ;EACR,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;;;;;EAKE,SAAS;EACT,gCAAgC;AAClC;;AAEA,oBAAoB;;AAEpB;EACE,iBAAiB;AACnB;;AAEA,wCAAwC;AACxC;;;;;;EAME,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;;;EAIE,SAAS;AACX;;AAEA;;;;EAIE,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;EAME,6BAA6B;AAC/B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;;;EAGE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;;;;EAKE,YAAY;EACZ,UAAU;AACZ;;AAEA,sBAAsB;;AAEtB,kBAAkB;AAClB;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;;GAEG;;AAEH;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;;EAKE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;;;EAKE,SAAS;EACT,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;;;;;EAKE,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;;;;;EAKE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;;;EAME,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;;EAIE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;;;EAKE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;;EAIE,0BAA0B;AAC5B;;AAEA,kBAAkB;;AAElB,WAAW;;AAEX;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;;EAIE,YAAY;EACZ,aAAa;AACf;;AAEA;;;;;EAKE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;;;;;EAME,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;;;;;;;;;EAUE,aAAa;AACf;;AAEA;;;;;EAKE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;;;;EAKE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oDAAoD;EACpD,uBAAuB;EACvB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;;;EAIE,iEAAiE;EACjE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;;;;;;;;;;EAUE,aAAa;AACf;;AAEA;;;;EAIE,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,uBAAuB;AACzB;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,UAAU;AACZ;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;;;;;;EAME,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,iEAAiE;EACjE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iEAAiE;EACjE,UAAU;AACZ;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA,WAAW;;AAEX,eAAe;AACf;;;;;EAKE,gBAAgB;AAClB;;AAEA;;;;;EAKE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;;;EAME,gCAAgC;EAChC,YAAY;EACZ,oBAAoB;EACpB,cAAc;AAChB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA,eAAe;;AAEf,mBAAmB;AACnB;;;;EAIE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;;;;EAIE,2BAA2B;AAC7B;;AAEA;;;;;EAKE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;;AAGA;;;;EAIE,kBAAkB;AACpB;;AAEA;;;;;EAKE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;EAIE,WAAW;EACX,YAAY;EACZ,gEAAgE;EAChE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;;;;EAKE,YAAY;AACd;;AAEA;;;;;;EAME,gCAAgC;AAClC;AACA;;;;;;EAME,uCAAuC;AACzC;;AAEA;;;;;EAKE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,gCAAgC;AAClC;;AAEA;;;;;EAKE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,oCAAoC;AACtC;;AAEA;;;;;;EAME,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;;AAEA;;;;;;EAME,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,cAAc;AAChB;;AAEA;;;;;;;EAOE,aAAa;AACf;;AAEA;;;;;;EAME,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;;;;;;;EAOE,qBAAqB;AACvB;;AAEA;;;;;;;EAOE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;;;;;EAKE,kCAAkC;AACpC;;AAEA;;;;;EAKE,2CAA2C;AAC7C;;AAEA;;;;;EAKE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;;;;;;EAME,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;;;;;EAME,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;;;;;;;EAOE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,QAAQ;AACV;AACA;;;;;;;EAOE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;;;;;;EAOE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;;;;;EAQE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;;;;;;;;EAQE,SAAS;AACX;AACA;;;;;;;;EAQE,qBAAqB;AACvB;AACA;;;;;;;;EAQE,kBAAkB;EAClB,QAAQ;AACV;AACA;;;;;;;;;EASE,qBAAqB;AACvB;;AAEA;;;;;EAKE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;;;;;EAME,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;;;;EAME,kBAAkB;AACpB;;AAEA;;;;;EAKE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;;;;;;EAME,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;;;;;EAKE,iEAAiE;EACjE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;;;;;;;;EAUE,aAAa;AACf;;AAEA;;;;;;EAME,uBAAuB;AACzB;;AAEA;;;;;EAKE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;;;;EAME,SAAS;EACT,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;;;;EAKE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;;;;;EAKE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;;;;;EAKE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,yBAAyB;AAC3B;AACA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;;;;;;;;;;;EAWE,yBAAyB;AAC3B;;AAEA,mBAAmB;;AAEnB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;;;;;EAKE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;;;EAKE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;;;;EAKE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,SAAS;EACT,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,OAAO;AACT;;AAEA;;;EAGE,YAAY;EACZ,YAAY;EACZ,SAAS;AACX;;AAEA;;;EAGE,YAAY;AACd;;;AAGA;;;;IAII,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;;;IAII,YAAY;IACZ,aAAa;IACb,uBAAuB;AAC3B;;AAEA;;IAEI,YAAY;IACZ,YAAY;AAChB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;;IAGI,YAAY;IACZ,aAAa;AACjB;;;AAGA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;EAGE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;EAGE,SAAS;EACT,WAAW;EACX,YAAY;AACd","sourcesContent":["/* New theme setting */\n.shopify-integration-setting-visual-editor .Polaris-FullscreenBar {\n  z-index: 517;\n  box-shadow: 0px 0px 1px 0px #00000040, 0px 2px 1px 0px #0000000d;\n}\n\n.shopify-integration-setting-visual-editor .Polaris-Frame__Content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-header {\n  display: flex;\n  flex-grow: 1;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  padding: 0 1rem;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-header .theme-name {\n  display: flex;\n  align-items: center;\n  width: 250px;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-header .theme-name p {\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-header .theme-name p {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-header .theme-name .Polaris-Badge {\n  background: #ebf9fc;\n  color: #2c6ecb;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  margin-left: 8px;\n  flex-shrink: 0;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-header .theme-action {\n  display: flex;\n  align-items: center;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-header\n  .visual-editor-header--color-picker {\n  width: 36px;\n  height: 36px;\n  margin-left: 24px;\n  cursor: pointer;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-header\n  .visual-editor-header--color-picker:hover {\n  background-color: #f6f6f7;\n}\n\n.shopify-integration-setting-visual-editor .Polaris-FullscreenBar__BackAction {\n  display: none;\n}\n\n.shopify-integration-setting-visual-editor .BC-BackAction {\n  display: flex;\n  padding: 0 16px;\n  border-right: 1px solid #e1e3e5 !important;\n}\n\n.shopify-integration-setting-visual-editor .BC-BackAction .Polaris-Icon {\n  margin: 0 !important;\n}\n\n.shopify-integration-setting-popover-menu {\n  min-width: 198px;\n}\n\n.shopify-integration-setting-popover-menu .Polaris-ActionList__Item:hover {\n  background-color: #ecf6f1;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-header__action\n  .Polaris-ButtonGroup__Item {\n  margin-left: 16px;\n}\n\n.shopify-integration-setting-visual-editor .btn-dots {\n  border-radius: 4px;\n  border: 1px solid #babfc3;\n}\n\n.shopify-integration-setting-visual-editor .btn-dots button {\n  background-color: #fff !important;\n  padding: 8px 9px;\n}\n\n.shopify-integration-setting-visual-editor .btn-dots:hover button {\n  background-color: #f1f2f3 !important;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body {\n  width: 100%;\n  display: flex;\n  height: calc(100vh - 56px);\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body.warning {\n  height: calc(100vh - 104px);\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-settings {\n  width: 300px;\n  height: 100%;\n  background: #ffffff;\n  border-right: 1px solid #e1e3e5;\n  overflow: auto;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-preview {\n  /* transition: 0.4s all ease-in-out; */\n  position: relative;\n  /* overflow: unset;\n  overflow-x: hidden; */\n}\n\n@media screen and (max-width: 1440px) {\n  .shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-preview {\n    padding: 0 8px;\n  }\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  #preview-shopify-integration-setting {\n  width: 100%;\n  height: 100%;\n  border: none;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  #preview-shopify-integration-setting-quickview {\n  position: fixed;\n  top: 54px;\n  left: 350px;\n  width: calc(100% - 350px);\n  height: calc(100% - 54px);\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  #preview-shopify-integration-setting-quickview.preview-quickview--mobile {\n  width: 375px;\n  top: 56px;\n  left: 50%;\n  border: 0;\n  height: calc(100% - 56px);\n}\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  #preview-shopify-integration-setting-quickview.preview-quickview--fullscreen {\n  width: 100%;\n  left: 0;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  #preview-shopify-integration-setting-cart.preview-cart--mobile {\n  width: 497px;\n  top: 54px;  \n  left: 45%;\n  border: 0;\n  height: calc(100% - 54px);\n}\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  #preview-shopify-integration-setting-cart.preview-cart--mobile.preview-cart--side {\n  width: 340px;\n  left: 50%;\n}\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  #preview-shopify-integration-setting-cart.preview-cart--fullscreen {\n  width: 100%;\n  left: 0;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  #preview-shopify-integration-setting-cart {\n  position: fixed;\n  top: 54px;\n  left: 350px;\n  width: calc(100% - 350px);\n  height: calc(100% - 54px);\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body.desktop .visual-editor-preview {\n  width: calc(100% - 352px);\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body.mobile .visual-editor-preview {\n  width: 375px !important;\n  margin: 0 auto;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-preview.full {\n  width: 100%;\n  left: 0;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview.overflow-hidden {\n  overflow: hidden;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview\n  .boost-sd__filter-block {\n  width: calc(100%);\n  /* transition: 0.4s all ease-in-out; */\n  position: relative;\n  height: 100%;\n  overflow: auto;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-preview .btn-expand {\n  width: 60px;\n  height: 60px;\n  background: #fafbfb;\n  border-width: 0px 0px 1px 1px;\n  border-style: solid;\n  border-color: #e1e3e5;\n  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.1);\n  transition: 0.3s all ease-in-out;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  right: 0;\n  cursor: pointer;\n  transform: translate(80px, 0);\n  z-index: 516;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview\n  .btn-expand.show {\n  transform: translate(0, 0);\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview.overflow-hidden\n  .btn-expand.show {\n  box-shadow: none;\n  border-bottom: none;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-preview .loading {\n  position: fixed;\n  top: 0;\n  left: 300px;\n  z-index: 99;\n  width: calc(100% - 600px);\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview.full\n  .loading {\n  width: calc(100% - 300px);\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview\n  .loading\n  .Polaris-Spinner\n  svg {\n  fill: white;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-left-panel-container {\n  display: flex;\n  width: 0;\n  height: 100%;\n  background: #ffffff;\n  border-left: 1px solid #e1e3e5;\n  /* transition: 0.3s all ease-in-out; */\n  /* position: fixed;\n  top: 56px;\n  left: 0; */\n  transform: translate(-360px, 0);\n  z-index: 500;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-left-panel-container.opened {\n  transform: translate(0, 0);\n  width: 352px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel-container {\n  width: 300px;\n  height: 100%;\n  background: #ffffff;\n  border-left: 1px solid #e1e3e5;\n  position: relative;\n  transition: 0.3s all ease-in-out;\n  position: fixed;\n  top: 56px;\n  right: 0;\n  transform: translate(360px, 0);\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel-container.opened {\n  transform: translate(0, 0);\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-right-panel__scroll {\n  overflow: auto;\n  height: calc(100% - 108px);\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__scroll.not-remove {\n  height: calc(100% - 56px);\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-right-panel {\n  margin-top: -1rem;\n  min-height: calc(100% - 60px);\n  padding: 1rem;\n  padding-top: 0;\n  padding-bottom: 1px;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .form-container .default-text-style {\n  font-weight: 400 !important;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel\n  .Polaris-Label__Text--disabled {\n  color: #8c9196;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel\n  .visual-editor-right-panel__content.h-full {\n  max-height: 100%;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .form-container .Polaris-FormLayout {\n  margin-top: 0;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section.form-section--bordered {\n  box-shadow: inset 0px 1px 0px #e4e5e7;\n  margin: 0 -16px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .section-title-collapse__wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 18px 16px;\n  cursor: pointer;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .section-title-collapse__wrapper\n  .section-title {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  color: #6d7175;\n  margin: 0 !important;\n  display: flex;\n  align-items: center;\n  text-transform: uppercase;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .section-title-collapse__wrapper\n  .section-title.uppercase {\n  text-transform: uppercase;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .section-title-collapse__wrapper\n  .section-title\n  .Polaris-Icon {\n  display: flex;\n  align-items: center;\n  max-width: max-content;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .section-title-collapse__wrapper\n  .section-title\n  .Polaris-Icon__Svg {\n  width: 14px;\n  height: 14px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .section-title-collapse__wrapper\n  .caret {\n  transition: 0.3s all;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .section-title-collapse__wrapper\n  .caret.closed {\n  transform: rotate(180deg);\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .section-title-collapse__wrapper\n  .caret.collapsed {\n  transform: rotate(90deg);\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .ReactCollapse--collapse {\n  padding: 0 16px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .ReactCollapse--collapse[aria-hidden='false'] {\n  margin-bottom: 20px;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .form-container .form-title {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  display: flex;\n  align-items: center;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-title\n  .Polaris-Icon {\n  margin: 0;\n  width: 12px;\n  height: 12px;\n  position: relative;\n  top: 2px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  margin-bottom: 8px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section__item\n  .title {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  margin-bottom: 4px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section__item\n  .title.title--small {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  margin-bottom: 8px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .form-section__item\n  + .form-section__item {\n  margin-top: 8px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .form-section__item\n  .Polaris-Connected__Item:first-child {\n  align-self: center;\n  width: calc(100% - 34px - 58px);\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .form-section__item\n  .Polaris-Connected__Item:last-child {\n  margin-left: 0;\n  width: 34px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .form-section__item.form-section__item--slider\n  .Polaris-TextField__Backdrop {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .form-section__item\n  .Polaris-Connected__Item\n  .Polaris-TextField__Input {\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .form-section__item\n  .Polaris-Connected__Item--primary {\n  width: 58px;\n  min-width: 58px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .form-section__item\n  .text-field-unit {\n  border-radius: 0px 4px 4px 0px;\n  background: #f1f2f3;\n  border: 1px solid #babfc3;\n  border-left: 0;\n  box-shadow: inset 0px 2px 0px rgba(0, 0, 0, 0.05);\n  padding: 7px 8px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .form-section__item\n  .text-field-unit\n  span {\n  position: relative;\n  top: -1px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .form-section__item\n  .Polaris-RangeSlider-SingleThumb__Input {\n  --pc-single-thumb-progress-lower: #008060;\n  --p-focused: transparent;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .form-section__item\n  .Polaris-RangeSlider-SingleThumb__Input::-webkit-slider-thumb {\n  background: #008060;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .form-section__item\n  .Polaris-RangeSlider-SingleThumb--disabled\n  .Polaris-RangeSlider-SingleThumb__Input::-webkit-slider-thumb {\n  background: #f1f1f1 !important;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .form-section__item\n  .Polaris-RangeSlider-SingleThumb__Input::-moz-range-thumb {\n  background: #008060;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .form-section__item\n  .Polaris-RangeSlider-SingleThumb--disabled\n  .Polaris-RangeSlider-SingleThumb__Input::-moz-range-thumb {\n  background: #f1f1f1 !important;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .form-section__item.form-section__item--small-spacing {\n  margin-top: 5px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .form-section__item.form-section__item--medium-spacing {\n  margin-top: 12px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .form-section__item.form-section__item--standard-spacing {\n  margin-top: 16px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .form-section__item\n  .Polaris-TextField__Input {\n  padding-top: 6px;\n  padding-bottom: 6px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .form-section__item.form-section__item--bordered-top {\n  border-top: 1px solid #e1e3e5;\n  padding-top: 16px;\n  margin-top: 20px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .form-section__item\n  > .title--medium {\n  font-weight: 600;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .BC-ThemeSettings_Dropzone {\n  padding: 25px 47px;\n  background: #f1f2f3;\n  border-radius: 4px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .BC-ThemeSettings_Dropzone\n  .custom-dropzone-standard-v2\n  .Polaris-DropZone__Container\n  > div {\n  padding: 24px 12px 16px !important;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .BC-ThemeSettings_Dropzone\n  .custom-dropzone-standard-v2.uploaded\n  .Polaris-DropZone__Container\n  > div {\n  padding: 24px 12px 8px !important;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .BC-ThemeSettings_Dropzone\n  .Polaris-Stack__Item\n  .Polaris-Stack__Item {\n  margin-top: 4px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .BC-ThemeSettings_Dropzone\n  .Polaris-TextStyle--variationSubdued {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #8c9196;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .BC-ThemeSettings_Dropzone\n  .Polaris-DropZone--hasOutline:not(.Polaris-DropZone--focused)::after {\n  border-radius: 4px;\n  border: 1px solid #babfc3;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .BC-ThemeSettings_Dropzone\n  .Polaris-DropZone\n  .Polaris-TextStyle--variationSubdued {\n  color: #202223;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .BC-ThemeSettings_Dropzone\n  .Polaris-DropZone.Polaris-DropZone--isDisabled\n  .Polaris-TextStyle--variationSubdued {\n  color: #8c9196;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .form-container .form-link {\n  color: #2c6ecb;\n  align-items: center;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-link\n  a:visited {\n  color: #2c6ecb;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-link\n  .Polaris-Icon {\n  margin: 0;\n  margin-left: 2px;\n  display: inline-block;\n  position: relative;\n  top: 2.5px;\n  width: 15px;\n  height: 15px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-link\n  .Polaris-Icon\n  svg {\n  fill: #2c6ecb;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-link.form-link--normal\n  .Polaris-Icon\n  svg {\n  fill: #5c5f62;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-link.form-link--normal\n  .Polaris-Icon {\n  top: 1px;\n  margin-left: 0;\n  width: 14px;\n  height: 14px;\n}\n\n.form-link__product-image-area-tooltip .form-link__product-image-area-tooltip__top {\n  width: 142px;\n  height: 145px;\n  display: flex;\n  flex-direction: column;\n  gap: 14.44px;\n  background-image: url('https://cdn.boostcommerce.io/assets/theme-setting/sample.svg');\n  background-size: 100% 100%;\n  background-color: #edeeef;\n}\n\n.form-link__product-image-area-tooltip\n  .form-link__product-image-area-tooltip__top\n  .form-link__product-image-area-tooltip__item {\n  width: 100%;\n  height: 38px;\n  border-radius: 4px;\n  border: 1.455px dashed #5c5f62;\n  background: rgba(255, 255, 255, 0.7);\n}\n\n.form-link__product-image-area-tooltip\n  .form-link__product-image-area-tooltip__top\n  .form-link__product-image-area-tooltip__item.active {\n  background: #2c6ecb;\n  border-color: transparent;\n}\n\n.form-link__product-image-area-tooltip .form-link__product-image-area-tooltip__body {\n  margin-top: 8.73px;\n}\n\n.form-link__product-image-area-tooltip .form-link__product-image-area-tooltip__body .name {\n  font-size: 10.182px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  letter-spacing: 0.102px;\n}\n\n.form-link__product-image-area-tooltip .form-link__product-image-area-tooltip__body .vendor {\n  font-size: 8px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  letter-spacing: 0.4px;\n  margin-top: 3px;\n  color: #7d7d7d;\n}\n\n.form-link__product-image-area-tooltip .form-link__product-image-area-tooltip__body .price {\n  font-family: Poppins;\n  font-size: 11.636px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  letter-spacing: 0.582px;\n  margin-top: 6px;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .form-container .icon-app-rating {\n  width: 32px;\n  height: 32px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .icon-app-rating\n  img {\n  max-width: 100%;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .input-wrapper-suffix {\n  position: relative;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .input-wrapper-suffix\n  > div:first-child {\n  z-index: 1;\n  position: relative;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .input-wrapper-suffix\n  .Polaris-TextField__Input {\n  padding-right: 50px;\n  min-height: 48px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .input-wrapper-suffix\n  .select-borderless {\n  position: absolute;\n  bottom: 8px;\n  right: 8px;\n  z-index: 10;\n  background-color: transparent;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .input-wrapper-suffix\n  .select-borderless\n  > div\n  > div {\n  width: max-content;\n  border: none !important;\n  box-shadow: none !important;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .input-wrapper-suffix\n  .select-borderless\n  .BC-Select__control {\n  min-height: auto;\n  width: 32px;\n  height: 32px;\n  cursor: pointer;\n  border: none !important;\n  box-shadow: none !important;\n  background: #f1f2f3;\n  border-radius: 4px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .input-wrapper-suffix\n  .select-borderless\n  .BC-Select__control\n  .BC-Select__value-container {\n  justify-content: center;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .input-wrapper-suffix\n  .select-borderless\n  .BC-Select__control\n  .BC-Select__placeholder {\n  font-size: 18px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .BC-Select__control--is-disabled {\n  background: #fafbfb;\n  border: 1px solid #c9cccf;\n  opacity: 0.6;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .BC-Select__control--is-disabled\n  .BC-Select__placeholder {\n  color: #8c9196;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .BC-Select__control--is-disabled\n  .BC-Select__indicator\n  .Polaris-Icon__Svg {\n  fill: #8c9196;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section\n  .BC-Select__single-value\n  .help-text {\n  display: none;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview:has(.visual-editor-preview__overlay)\n  .loading {\n  display: none;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview:has(.visual-editor-preview__overlay)\n  .boost-sd__filter-block {\n  overflow: hidden;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview\n  .visual-editor-preview__overlay-cart,\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview\n  .visual-editor-preview__overlay.mobile {\n  width: 100%;\n  background-color: rgb(34, 34, 34, 0.6);\n  position: fixed;\n  z-index: 50;\n  top: 0;\n  left: 0;\n  height: 100%;\n  overflow: hidden;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview.full\n  .visual-editor-preview__overlay {\n  width: 100%;\n  /* overflow: unset; */\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview\n  .visual-editor-preview__overlay\n  .boost-sd__modal-close-btn--on-overlay {\n  top: 56px;\n}\n\n.product-gallery--vertical .product-gallery__pagination-wrapper .Polaris-Icon {\n  transform: rotate(-90deg);\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview\n  .boost-sd__modal-backdrop {\n  background-color: transparent;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview\n  .boost-sd__cart:not(.boost-sd__cart--side) {\n  height: initial;\n  max-height: min(640px, calc(100% - 120px));\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview\n  .boost-sd__cart:not(.boost-sd__cart--side)\n  .boost-sd__cart-body {\n  height: 340px;\n}\n\n.BC-Select__option {\n  border-radius: 4px;\n  margin-top: 4px;\n}\n\n.BC-Select__option:first-child {\n  margin-top: 0px !important;\n}\n\n.BC-Select__option:not(.BC-Select__option--is-selected) .help-text {\n  color: #6d7175;\n}\n\n.BC-Select__option.BC-Select__option--is-selected .help-text {\n  color: white;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .grid-radio-button__wrapper {\n  background-color: #fafbfb;\n  padding: 8px;\n  border: 1px solid #c9cccf;\n  border-radius: 4px;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .grid-radio-button {\n  margin: auto;\n  width: 140px;\n  min-width: 140px;\n  display: grid;\n  grid-template-columns: 44px 44px 44px;\n  gap: 4px;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .grid-radio-button .Polaris-Button {\n  height: 44px;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .radio-button-wrapper {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  column-gap: 8px;\n  margin-top: 4px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper.radio-button-wrapper--no-gap {\n  column-gap: 0;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper\n  .radio-button-2\n  .Polaris-Button {\n  padding: 8px 16px;\n  position: relative;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper.radio-button-wrapper--full-width\n  .radio-button-2 {\n  width: 100% !important;\n  flex-grow: 1 !important;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper.radio-button-wrapper--full-width\n  .radio-button-2\n  .Polaris-Button {\n  padding: 8px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper.radio-button-wrapper--no-wrap {\n  flex-wrap: nowrap;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper.radio-button-wrapper--no-gap\n  .radio-button-2:first-child\n  .Polaris-Button {\n  border-right: 0;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper.radio-button-wrapper--no-gap\n  .radio-button-2:last-child\n  .Polaris-Button {\n  border-left: 0;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper.radio-button-wrapper--no-radius-middle\n  .radio-button-2:nth-child(2)\n  .Polaris-Button {\n  border-radius: 0;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper.radio-button-wrapper--bordered\n  .radio-button-2:first-child\n  .Polaris-Button {\n  border-right: var(--p-border-width-1) solid var(--p-border-neutral-subdued);\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper.radio-button-wrapper--outline\n  .radio-button-2\n  .Polaris-Button.checked {\n  background-color: #fff;\n  border-color: #008060;\n  border-width: 2px;\n  color: #008060;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper.radio-button-wrapper--outline\n  .radio-button-2\n  .Polaris-Button.checked\n  .Polaris-Icon__Svg\n  rect,\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper.radio-button-wrapper--outline\n  .radio-button-2\n  .Polaris-Button.checked\n  .Polaris-Icon__Svg\n  path {\n  fill: #008060;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper\n  .radio-button-2\n  .Polaris-Button.checked\n  .icon-check {\n  position: absolute;\n  top: -8px;\n  right: -8px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-sidebar\n  .__react_component_tooltip,\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu\n  .menu-title\n  .__react_component_tooltip {\n  box-shadow: 0px 2px 10px 0px #0000001a, 0px 0px 2px 0px #00000033;\n  max-width: 25rem;\n  padding: var(--p-space-1) var(--p-space-2);\n  opacity: 1;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper\n  .radio-button-2\n  .__react_component_tooltip {\n  box-shadow: 0px 2px 10px 0px #0000001a, 0px 0px 2px 0px #00000033;\n  max-width: 25rem;\n  padding: var(--p-space-1) var(--p-space-2);\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-menu .color-form,\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu\n  .typography-section {\n  position: relative;\n  height: 100%;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-menu .btn-reset,\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu\n  .typography-section\n  .btn-reset {\n  position: absolute;\n  left: 52px;\n  bottom: 0;\n  width: calc(100% - 53px);\n  padding: 16px 0;\n  border-top: 1px solid #e1e3e5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  cursor: pointer;\n  color: #2c6ecb;\n  background-color: #fff;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu\n  .color-form\n  .btn-reset\n  svg,\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu\n  .typography-section\n  .btn-reset\n  svg {\n  width: 16px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu\n  .color-form\n  .btn-reset\n  svg\n  path,\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu\n  .typography-section\n  .btn-reset\n  svg\n  path {\n  fill: #2c6ecb;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu\n  .color-form\n  .btn-reset:hover,\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu\n  .typography-section\n  .btn-reset:hover {\n  background-color: #f6f6f7;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu\n  .color-form\n  .__react_component_tooltip {\n  box-shadow: 0px 2px 10px 0px #0000001a, 0px 0px 2px 0px #00000033;\n  max-width: 25rem;\n  padding: 4px 8px;\n  opacity: 1;\n  border-radius: 4px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu\n  .menu-title\n  .__react_component_tooltip::after,\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu\n  .menu-title\n  .__react_component_tooltip::before,\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-sidebar\n  .__react_component_tooltip::after,\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-sidebar\n  .__react_component_tooltip::before,\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper\n  .radio-button-2\n  .__react_component_tooltip::after,\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper\n  .radio-button-2\n  .__react_component_tooltip::before,\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu\n  .color-form\n  .__react_component_tooltip::after,\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu\n  .color-form\n  .__react_component_tooltip::before {\n  display: none;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper.radio-button-wrapper--large {\n  column-gap: 6px;\n  row-gap: 10px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper.radio-button-wrapper--medium {\n  column-gap: 7px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper.radio-button-wrapper--large\n  .radio-button-2 {\n  flex-basis: 130px;\n  height: 48px;\n  position: relative;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper.radio-button-wrapper--large\n  .radio-button-2\n  .check {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper.radio-button-wrapper--medium\n  .radio-button-2 {\n  width: 84px;\n  height: 48px;\n  flex-grow: unset;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper.radio-button-wrapper--large\n  .radio-button-2\n  .Polaris-Button,\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper.radio-button-wrapper--medium\n  .radio-button-2\n  .Polaris-Button {\n  height: 100%;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper.radio-button-wrapper--large\n  .radio-button-2\n  .Polaris-Button__Content {\n  font-size: 18px;\n  font-weight: 500;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper.radio-button-wrapper--large\n  .radio-button-2\n  .Polaris-Button__Content\n  s {\n  font-size: 12px;\n  font-weight: 400;\n  color: #7a7a7a;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper.radio-button-wrapper--large\n  .radio-button-2\n  .Polaris-Button.checked\n  .Polaris-Button__Content\n  s {\n  color: #fff;\n}\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper.radio-button-wrapper--large.radio-button-wrapper--outline\n  .radio-button-2\n  .Polaris-Button.checked\n  .Polaris-Button__Content\n  s {\n  color: #7a7a7a;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper.radio-button-wrapper--large\n  .radio-button-2\n  .Polaris-Button.full-size\n  .Polaris-Icon {\n  width: 100%;\n  height: 100%;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper.radio-button-wrapper--medium\n  .radio-button-2\n  .Polaris-Button\n  .Polaris-Icon {\n  width: 52px;\n  height: 16px;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-settings {\n  position: relative;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-settings .inner {\n  overflow: auto;\n  height: calc(100% - 127px);\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-settings\n  .theme-setting-menu-divider-section {\n  padding: 12px 20px;\n  background: #f1f2f3;\n  border-top: 1px solid #e1e3e5;\n  border-bottom: 1px solid #e1e3e5;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-settings\n  .theme-setting-menu-divider-section\n  .divider-title {\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  text-transform: uppercase;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-settings\n  .theme-setting-menu-divider-section\n  .Polaris-Icon {\n  width: 14px;\n  height: 14px;\n  margin-left: 4px;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .reset-wrapper {\n  padding: 1rem;\n  position: absolute;\n  bottom: 56px;\n  width: 100%;\n  box-shadow: inset 0px 1px 0px #e4e5e7;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .reset-wrapper button {\n  white-space: nowrap;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-settings\n  .menu-section {\n  border-bottom: 1px solid #e1e3e5;\n  padding: 8px 20px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-settings\n  .menu-section:last-child {\n  box-shadow: unset;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-settings\n  .menu-section\n  p {\n  color: #6d7175;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  margin-top: 2px;\n  margin-bottom: 1px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-left-panel-container\n  .choose-layout-wrapper {\n  padding: 16px;\n  background-color: #fafbfb;\n  border: 1px solid #e1e3e5;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-left-panel-container\n  .choose-layout-wrapper__layout {\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-left-panel-container\n  .choose-layout-wrapper\n  .Polaris-Button {\n  width: 100%;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .list-layout-container {\n  position: fixed;\n  z-index: 99;\n  box-shadow: 0px 0px 1px 0px #00000040, 0px 2px 1px 0px #0000000d;\n  background-color: #fff;\n  width: 200px;\n  height: 100%;\n  top: 0;\n  left: 351px;\n  padding: 12px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .list-layout-container\n  .layout-sample {\n  position: relative;\n  width: 95%;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .list-layout-container\n  .layout-sample\n  .check {\n  position: absolute;\n  top: -5px;\n  right: -6px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .list-layout-container\n  .layout-sample\n  img {\n  width: 100%;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .list-layout-container\n  .layout-sample.active\n  img {\n  outline: 2px solid #005e46;\n  outline-offset: -2px;\n  border-radius: 6px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .list-layout-container\n  .layout-sample\n  .premium-upgrade-link {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  text-align: center;\n  white-space: nowrap;\n  margin-top: -3.5px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .list-layout-container\n  .layout-sample\n  .premium-upgrade-link\n  p {\n  font-size: 14px;\n  color: #2c6ecb;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .list-layout-container__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .list-layout-container__header\n  .title {\n  font-weight: 600;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .list-layout-container__header\n  .Polaris-Icon__Svg\n  path {\n  fill: #5c5f62;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .list-layout-container__body {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-top: 12px;\n  overflow: auto;\n  height: calc(100% - 34px);\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .list-layout-container__body\n  .Polaris-Choice__Control {\n  visibility: hidden;\n  width: 0;\n  margin: 0;\n  margin-top: 6px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .list-layout-container__body\n  .Polaris-Choice__Descriptions {\n  padding-left: 0;\n}\n\n.widget-layout-settings > div:not(:first-child),\n.widget-title-settings > div:not(:first-child) {\n  padding-top: 16px;\n}\n\n.widget-layout-settings div ul li {\n  padding-top: 12px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-settings.title-bold-normal {\n  height: 56px;\n  display: flex;\n  align-items: center !important;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-header .select-theme-preview {\n  display: inline-flex;\n  align-items: center;\n  width: 100%;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-header\n  .select-theme-preview\n  > div:first-child {\n  flex-grow: 1;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-header .Polaris-Tabs__Wrapper {\n  border-bottom-color: transparent;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-header\n  .Polaris-Tabs__Tab\n  .Polaris-Tabs__Title::before {\n  bottom: -9px;\n  border-radius: 0;\n  height: 2px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-header\n  .Polaris-Tabs__Tab--selected\n  .Polaris-Tabs__Title::before {\n  background: #44474a;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-header\n  .Polaris-Tabs__Tab--selected\n  .Polaris-Icon__Svg {\n  fill: #44474a;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-header .theme-preview {\n  width: 493px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  margin-left: -160px;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-header .theme-preview.disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-header\n  .theme-preview\n  .theme-preview-label {\n  margin-right: 20px;\n  /* margin-left: 20px; */\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-header\n  .theme-preview\n  .theme-preview-label\n  span {\n  margin-top: 10px;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-header .Polaris-Tabs {\n  margin-left: 20px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-header\n  .Polaris-Tabs__DisclosureActivator {\n  display: none;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-right-panel-container .title-section {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  margin-bottom: 0;\n  padding: 18px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-right-panel-container\n  .title-section\n  .btn-collapse {\n  cursor: pointer;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-right-panel-container\n  .title-section\n  .Polaris-Icon {\n  margin: 0;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-right-panel .description-panel {\n  color: #6d7175;\n  margin-top: 1rem;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-right-panel__remove {\n  position: absolute;\n  bottom: 56px;\n  left: 0;\n  display: flex;\n  padding: 16px;\n  box-shadow: inset 0px 1px 0px #e4e5e7;\n  width: 100%;\n  cursor: pointer;\n  font-weight: 600;\n  color: #6d7175;\n  background: #fff;\n  z-index: 999;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__remove\n  .Polaris-Icon {\n  margin: 0;\n  margin-right: 4px;\n}\n\n.visual-editor-right-panel .Polaris-Tooltip-TooltipOverlay {\n  max-width: 254px;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-settings .title {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  padding: 18px 16px;\n  border-bottom: 1px solid #e1e3e5;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-settings .theme-setting-menu-item {\n  border-bottom: 1px solid #e1e3e5;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item.borderless {\n  box-shadow: none;\n  border-bottom: none;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item:last-child {\n  box-shadow: none;\n  border-bottom: none;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.not-collapsible {\n  padding-left: 41px;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-settings .ReactCollapse--collapse {\n  padding-left: 16px;\n  padding-right: 16px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .ReactCollapse--collapse {\n  padding: 0;\n  margin-left: 40px;\n  margin-right: 8px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item.has-submenu\n  .ReactCollapse--collapse {\n  margin-left: 40px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item.has-submenu\n  .ReactCollapse--collapse\n  .ReactCollapse--collapse {\n  margin-left: 26px;\n  margin-right: 0;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper {\n  display: flex;\n  align-items: center;\n  padding: 0 16px;\n  transition: 0.3s all ease-in-out;\n  cursor: pointer;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper\n  .title-inner {\n  display: flex;\n  align-items: center;\n  padding: 8px 0;\n  width: 100%;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item.has-submenu\n  .title-wrapper {\n  padding-right: 0;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item.has-submenu\n  .title-wrapper\n  > .title-inner {\n  padding-right: 16px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item.has-submenu\n  .ReactCollapse--collapse\n  .title-wrapper {\n  padding-left: 4px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.active {\n  background: #f1f8f5;\n  color: #008060;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.active\n  .Polaris-Icon__Svg {\n  fill: #008060;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.active\n  .Polaris-Icon__Svg\n  path {\n  fill: #008060;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.active.disabled\n  .Polaris-Icon__Svg\n  path {\n  fill: #8c9196 !important;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper\n  > .btn-view-by-page {\n  margin-left: auto;\n  margin-right: 28px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.not-collapsible {\n  padding: 0;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.not-collapsible\n  .title-inner {\n  padding-left: 41px;\n  padding-right: 16px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.active {\n  background: #f1f8f5;\n  color: #008060;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.active\n  .Polaris-Icon__Svg {\n  fill: #008060;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.disabled {\n  color: #8c9196 !important;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.disabled\n  .Polaris-Icon__Svg {\n  fill: #8c9196 !important;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.disabled\n  ~ .ReactCollapse--collapse\n  .theme-setting-menu-children:not(.btn-add) {\n  color: #8c9196 !important;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.disabled\n  ~ .ReactCollapse--collapse\n  .theme-setting-menu-children:not(.btn-add)\n  .Polaris-Icon__Svg\n  path {\n  fill: var(--p-icon);\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.disabled\n  ~ .ReactCollapse--collapse\n  .theme-setting-menu-children.disabled:not(.btn-add)\n  .Polaris-Icon__Svg\n  path {\n  fill: #8c9196 !important;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-settings .theme-setting-menu-children,\n#draggable .theme-setting-menu-children {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px;\n  transition: 0.3s background ease-in-out;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children.area {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  justify-content: flex-start;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-settings .theme-setting-menu-droppable {\n  min-height: 4px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children.active,\n#draggable .theme-setting-menu-children.active {\n  background: #f1f8f5;\n  color: #008060;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children.active\n  .Polaris-Icon__Svg\n  rect,\n#draggable .theme-setting-menu-children.active .Polaris-Icon__Svg rect {\n  fill: #008060;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children\n  .Polaris-Icon {\n  margin: 0;\n  margin-right: 8px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children__action\n  .Polaris-Icon {\n  margin: 0;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children.disabled,\n#draggable .theme-setting-menu-children.disabled {\n  color: #8c9196 !important;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children.disabled\n  .Polaris-Icon\n  svg,\n#draggable .theme-setting-menu-children.disabled .Polaris-Icon svg {\n  fill: #8c9196 !important;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children.disabled\n  .btn-drag\n  .Polaris-Icon\n  svg,\n#draggable .theme-setting-menu-children.disabled .btn-drag .Polaris-Icon svg {\n  fill: var(--p-icon) !important;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children.active\n  .Polaris-Icon\n  svg,\n#draggable .theme-setting-menu-children.active .Polaris-Icon svg {\n  fill: #008060 !important;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children.active\n  .btn-drag\n  .Polaris-Icon\n  svg,\n#draggable .theme-setting-menu-children.active .btn-drag .Polaris-Icon svg {\n  fill: #008060 !important;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children.active.disabled\n  .btn-view\n  .Polaris-Icon\n  svg,\n#draggable .theme-setting-menu-children.active.disabled .btn-view .Polaris-Icon svg {\n  fill: #8c9196 !important;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.disabled\n  .btn-view-by-page,\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children.disabled\n  .btn-view,\n#draggable .theme-setting-menu-children.disabled .btn-view {\n  opacity: 1;\n  visibility: visible;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children.btn-add {\n  color: #2c6ecb;\n  justify-content: flex-start;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children.btn-add\n  .Polaris-Icon {\n  display: flex;\n  align-items: center;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children.btn-add\n  .Polaris-Icon\n  svg {\n  fill: #2c6ecb;\n  width: 16px;\n  height: 16px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children.btn-add.disabled {\n  pointer-events: none !important;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children__action,\n#draggable .theme-setting-menu-children .theme-setting-menu-children__action {\n  display: flex;\n  align-items: center;\n  column-gap: 8px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .btn-view-by-page,\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children__action\n  .btn-view,\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children__action\n  .btn-drag,\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children__action\n  .btn-remove {\n  visibility: hidden;\n  opacity: 0;\n  transition: 0.2s all;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children\n  .theme-setting-menu-children__action.show\n  .btn-view,\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children\n  .theme-setting-menu-children__action.show\n  .btn-drag,\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children\n  .theme-setting-menu-children__action.show\n  .btn-remove,\n#draggable .theme-setting-menu-children .theme-setting-menu-children__action.show .btn-view,\n#draggable .theme-setting-menu-children .theme-setting-menu-children__action.show .btn-drag,\n#draggable .theme-setting-menu-children .theme-setting-menu-children__action.show .btn-remove {\n  opacity: 1;\n  visibility: visible;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper:hover\n  .btn-view-by-page,\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children:hover\n  .theme-setting-menu-children__action\n  .btn-view,\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children:hover\n  .theme-setting-menu-children__action\n  .btn-drag,\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children:hover\n  .theme-setting-menu-children__action\n  .btn-remove,\n#draggable .theme-setting-menu-children:hover .theme-setting-menu-children__action .btn-view,\n#draggable .theme-setting-menu-children:hover .theme-setting-menu-children__action .btn-drag,\n#draggable .theme-setting-menu-children:hover .theme-setting-menu-children__action .btn-remove {\n  opacity: 1;\n  visibility: visible;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper:hover,\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children:hover,\n#draggable .theme-setting-menu-children:hover {\n  background: #f6f6f7;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.active:hover,\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children.active:hover,\n#draggable .theme-setting-menu-children.active:hover {\n  background: #f1f8f5;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children\n  > span,\n#draggable .theme-setting-menu-children > span {\n  display: block;\n  max-width: 125px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper\n  .caret {\n  padding: 8px 0;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper\n  .caret {\n  margin-right: 5px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper\n  .caret\n  .Polaris-Icon {\n  transition: 0.2s all ease-in-out;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper\n  .caret.closed\n  .Polaris-Icon {\n  transform: rotate(-90deg);\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper\n  .menu-title {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper\n  .menu-icon {\n  margin-right: 8px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper\n  .menu-icon\n  svg,\n.shopify-integration-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children.area\n  .menu-icon\n  svg {\n  width: 18px;\n  height: 18px;\n}\n\n.theme-setting-menu-children__menu-add {\n  padding: 8px 0;\n  min-width: 220px;\n}\n\n.theme-setting-menu-children__menu-add .Polaris-ActionList__Title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  color: #6d7175;\n  padding: 8px 16px;\n  text-transform: uppercase;\n}\n\n.theme-setting-menu-children__menu-add .Polaris-ActionList__Actions {\n  padding: 0;\n}\n\n.theme-setting-menu-children__menu-add .Polaris-ActionList__Item {\n  padding: 8px 16px;\n  border-radius: 0;\n  width: 219px;\n}\n\n.theme-setting-menu-children__menu-add .Polaris-ActionList__Item:hover {\n  color: #008060;\n  background: #f1f8f5;\n}\n\n.draggable-zone.dragging {\n  border-radius: 8px;\n  border: 1px dashed var(--interactive);\n}\n\n.draggable-zone.draggable-zone--margin-left {\n  margin-left: 18px;\n}\n\n.draggable-zone.dragging.draggable-zone--margin-left {\n  margin-right: 8px;\n}\n\n/* Ajax cart */\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview\n  .visual-editor-preview__overlay\n  .ajax-cart {\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  background: #ffffff;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview\n  .visual-editor-preview__overlay\n  .ajax-cart--popup {\n  top: 50%;\n  left: calc(58% - 352px);\n  transform: translate(0, -50%);\n  width: 732px;\n  max-height: min(640px, calc(100% - 60px - 60px));\n}\n\n@media screen and (max-width: 1280px) {\n  .shopify-integration-setting-visual-editor\n    .visual-editor-body\n    .visual-editor-preview\n    .visual-editor-preview__overlay\n    .ajax-cart--popup {\n    left: calc(62% - 352px);\n  }\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview\n  .visual-editor-preview__overlay\n  .boost-sd__cart--side {\n  height: calc(100% - 56px);\n  top: 56px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview\n  .visual-editor-preview__overlay.popup\n  .boost-sd__modal-container {\n  left: calc(52% - 352px);\n  top: 50%;\n  transform: translate(0, -50%);\n  position: absolute;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview.full\n  .visual-editor-preview__overlay.popup\n  .boost-sd__modal-container {\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n/* ----- Ajax cart */\n\n.btn-group-polaris .Polaris-ButtonGroup__Item {\n  margin-left: 10px;\n}\n\n/* Preview theme setting overwrite css */\n.boost-sd__filter-option-content-inner,\n.boost-sd__sorting-button,\n/* .boost-sd__pagination, */\n.boost-sd__search-form-input,\n.boost-sd__search-form .boost-sd__button,\n.boost-sd__filter-tree-toggle-button {\n  pointer-events: none;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-sidebar {\n  display: flex;\n  width: 52px;\n  height: 100%;\n  padding: 6px 0px;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n  border-right: 1px solid #e1e3e5;\n  background: #fff;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-sidebar__item {\n  cursor: pointer;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-sidebar__item\n  .Polaris-Icon {\n  margin: 0;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-sidebar__item\n  .Polaris-Icon__Svg {\n  width: 20px;\n  height: 20px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-sidebar__item\n  .Polaris-Icon--custom.Polaris-Icon--colorPrimary\n  .Polaris-Icon__Svg\n  path {\n  fill: var(--p-action-primary);\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-sidebar__item:hover,\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-sidebar__item.active {\n  background: #f1f2f3;\n}\n\n.BC-ThemeSetting-Editor-Page.shopify-integration-setting-visual-editor\n  ~ #PolarisPortalsContainer\n  .Polaris-PositionedOverlay {\n  z-index: 520;\n}\n\n.BC-ThemeSetting-Editor-Page.shopify-integration-setting-visual-editor\n  ~ #PolarisPortalsContainer\n  .Polaris-Modal-Dialog--sizeLarge.Polaris-Modal-Dialog--fullScreen {\n  max-width: 1164px;\n  height: calc(100vh - 3.75rem);\n}\n\n.BC-ThemeSetting-Editor-Page.shopify-integration-setting-visual-editor\n  ~ #PolarisPortalsContainer\n  .Polaris-Modal-Dialog--sizeLarge.Polaris-Modal-Dialog--fullScreen\n  .Polaris-Modal__Body\n  > .Polaris-Modal-Section {\n  height: 100%;\n  padding: 0;\n}\n\n/* New theme setting */\n\n/* Global styles */\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-menu {\n  width: 300px;\n  height: 100%;\n  background: #ffffff;\n  border-right: 1px solid #e1e3e5;\n  overflow: auto;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-menu-developer {\n  width: 300px;\n  height: 100%;\n  background: #ffffff;\n  border-right: 1px solid #e1e3e5;\n}\n\n/* .shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-menu.opened {\n  transform: translate(0, 0);\n} */\n\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-menu .title-wrapper {\n  border-bottom: 1px solid #e1e3e5;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-menu .menu-title h2 {\n  display: flex;\n  align-items: center;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-menu .menu-title,\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu-developer\n  .menu-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 16px;\n  height: 48px;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-menu .menu-title h2 {\n  font-weight: 600;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu-developer\n  .menu-title {\n  border-bottom: 1px solid #e1e3e5;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-menu .tooltip-icon {\n  display: flex;\n  margin-left: 6px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu\n  .tooltip-icon\n  #menu-question {\n  min-width: 130px;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-menu .product-guide {\n  padding: 0 16px;\n  padding-bottom: 17px;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-menu .form-link {\n  color: #2c6ecb;\n  align-items: center;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu\n  .form-link\n  a:visited {\n  color: #2c6ecb;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu\n  .form-link\n  .Polaris-Icon {\n  margin: 0;\n  margin-left: 2px;\n  display: inline-block;\n  position: relative;\n  top: 2.5px;\n  width: 15px;\n  height: 15px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu\n  .form-link\n  .Polaris-Icon\n  svg {\n  fill: #2c6ecb;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu\n  .form-link.form-link--normal\n  .Polaris-Icon\n  svg {\n  fill: #5c5f62;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu\n  .form-link.form-link--normal\n  .Polaris-Icon {\n  top: 1px;\n  margin-left: 0;\n  width: 14px;\n  height: 14px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu\n  .menu-title\n  .btn-back {\n  cursor: pointer;\n  margin-right: 8px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu\n  .menu-title\n  .btn-back\n  .Polaris-Icon {\n  width: 16px;\n  height: 16px;\n}\n\n.visual-editor-menu\n  .menu-container.menu-container--no-border-bottom\n  .menu-container__item:last-child {\n  border-bottom: 0 !important;\n}\n\n.visual-editor-menu .menu-container .menu-container__item {\n  display: flex;\n  padding: 0 12px 0 16px;\n  height: 40px;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #e1e3e5;\n  cursor: pointer;\n}\n\n.visual-editor-menu .menu-container.disabled .menu-container__item,\n.visual-editor-menu .menu-container .menu-container__item.disabled {\n  cursor: default;\n  pointer-events: none;\n}\n\n.visual-editor-menu .menu-container.disabled .menu-container__item .menu-container__item__name,\n.visual-editor-menu .menu-container .menu-container__item.disabled .menu-container__item__name {\n  opacity: 0.5;\n}\n\n.visual-editor-menu .menu-container.disabled .menu-container__item > .Polaris-Icon,\n.visual-editor-menu .menu-container .menu-container__item.disabled > .Polaris-Icon {\n  opacity: 0.5;\n}\n\n.visual-editor-menu .menu-container .menu-container__item.menu-container__item--start {\n  height: 68px;\n  align-items: flex-start;\n  padding-top: 6px;\n  padding-left: 6px;\n  padding-right: 6px;\n}\n\n.visual-editor-menu .menu-container .menu-container__item .Polaris-Icon {\n  margin-right: 0;\n}\n\n.visual-editor-menu .menu-container .menu-container__item:hover {\n  background-color: #f1f1f1;\n}\n\n.visual-editor-menu .menu-container .menu-container__item .menu-container__item__name {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  font-weight: 600;\n}\n\n.visual-editor-menu\n  .menu-container\n  .menu-container__item\n  .menu-container__item__name.menu-container__item__name--column {\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.visual-editor-menu .menu-container .menu-container__item .Polaris-Icon {\n  margin: 0;\n}\n\n.visual-editor-menu .menu-container .menu-container__item > .Polaris-Icon {\n  width: 14px;\n  height: 14px;\n}\n\n.visual-editor-menu\n  .menu-container\n  .menu-container__item\n  .menu-container__item__name\n  > .Polaris-Icon {\n  width: 16px;\n  height: 16px;\n}\n\n.visual-editor-menu .menu-global-styles-section {\n  padding: 16px;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-menu .form-container {\n  padding: 16px;\n  padding-top: 0;\n  height: calc(100% - 49px);\n  overflow: auto;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu.with-reset\n  .form-container {\n  height: calc(100% - 102px);\n}\n\n/* Global styles */\n\n/* Colors */\n\n.shopify-integration-setting-visual-editor .form-container .color-picker-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.shopify-integration-setting-visual-editor\n  .form-container\n  .color-picker-container.color-picker-container--column {\n  flex-direction: column;\n}\n\n.shopify-integration-setting-visual-editor\n  .form-container\n  .color-picker-container\n  .color-picker-item.color-picker-item--rectangle {\n  flex-grow: 1;\n  flex-basis: 0;\n}\n\n.shopify-integration-setting-visual-editor\n  .form-container\n  .color-picker-container\n  .color-picker-item.color-picker-item--rectangle\n  .color-picker-item__box-color {\n  height: 36px;\n  width: 100%;\n  border: 1px solid #e1e3e5;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  padding: 0 10px;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n\n.shopify-integration-setting-visual-editor\n  .form-container\n  .color-picker-container\n  .color-picker-item.color-picker-item--rectangle\n  .color-picker-item__box-color\n  .color-picker-item__value {\n  pointer-events: none;\n  margin-left: 6px;\n  font-size: 12px;\n}\n\n.shopify-integration-setting-visual-editor\n  .form-container\n  .color-picker-container\n  .color-picker-item.color-picker-item--rectangle\n  .color-picker-item__box-color\n  path {\n  fill: inherit;\n}\n\n.shopify-integration-setting-visual-editor\n  .form-container\n  .color-picker-container\n  .color-picker-item.color-picker-item--circle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.shopify-integration-setting-visual-editor\n  .form-container\n  .color-picker-container\n  .color-picker-item.color-picker-item--circle.not-connected-palette\n  > div:nth-child(3),\n.shopify-integration-setting-visual-editor\n  .form-container\n  .color-picker-container\n  .color-picker-item.color-picker-item--circle.connected-palette\n  > div:nth-child(2) {\n  display: none;\n}\n\n.shopify-integration-setting-visual-editor\n  .form-container\n  .color-picker-container\n  .color-picker-item.color-picker-item--circle\n  .color-picker-item__box-color {\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  border: 1px solid #c9cccf;\n}\n\n.shopify-integration-setting-visual-editor\n  .form-container\n  .color-picker-container\n  .color-picker-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.shopify-integration-setting-visual-editor\n  .form-container\n  .color-picker-container\n  .color-picker-info\n  .color-picker-item__name {\n  font-weight: 500;\n  margin-bottom: 2px;\n}\n\n.shopify-integration-setting-visual-editor\n  .form-container\n  .color-picker-container\n  .color-picker-info\n  .color-picker-item__value {\n  font-size: 12px;\n}\n\n.shopify-integration-setting-visual-editor\n  .form-container\n  .color-picker-container\n  .color-picker-info\n  .color-picker-item__value.color-picker-item__value--hex {\n  text-transform: uppercase;\n}\n\n.shopify-integration-setting-visual-editor .form-container .color-palette {\n  display: flex;\n  margin-top: 10px;\n}\n\n.shopify-integration-setting-visual-editor .form-container .color-palette-item {\n  height: 14px;\n  flex-grow: 1;\n  cursor: pointer;\n}\n\n.shopify-integration-setting-visual-editor .form-container .color-palette-item:hover {\n  box-shadow: 0px 0px 3.5px 2.25px rgba(0, 0, 0, 0.39);\n  outline: 2px solid #fff;\n  z-index: 10;\n  /* outline-offset: 2px; */\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .color-palette\n  .__react_component_tooltip {\n  box-shadow: 0px 2px 10px 0px #0000001a, 0px 0px 2px 0px #00000033;\n  max-width: 25rem;\n  padding: 4px 8px;\n  opacity: 1;\n  border-radius: 4px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu\n  .color-palette\n  .__react_component_tooltip::after,\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu\n  .color-palette\n  .__react_component_tooltip::before {\n  display: none;\n}\n\n.shopify-integration-setting-visual-editor\n  .form-container\n  .color-picker-item\n  .color-picker-item__empty {\n  height: 36px;\n  width: 100%;\n  border: 1px dashed #8c9196;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 10px;\n  cursor: pointer;\n  background-color: white;\n}\n\n.shopify-integration-setting-visual-editor\n  .form-container\n  .color-picker-item\n  .color-picker-item__empty:hover {\n  background-color: #f6f6f7;\n}\n\n.shopify-integration-setting-visual-editor\n  .form-container\n  .color-picker-item\n  .color-picker-item__empty\n  .Polaris-Icon {\n  width: 16px;\n  height: 16px;\n}\n\n.shopify-integration-setting-visual-editor .form-container .banner-warning-contrast {\n  margin-top: 16px;\n}\n\n.shopify-integration-setting-visual-editor\n  .form-container\n  .color-picker-item\n  .color-picker-item__activator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 20px;\n  width: 20px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.shopify-integration-setting-visual-editor\n  .form-container\n  .color-picker-item\n  .color-picker-item__activator:hover {\n  background-color: #f6f6f7;\n}\n\n.shopify-integration-setting-visual-editor\n  .form-container\n  .color-picker-item\n  .color-picker-item__activator:hover\n  path {\n  fill: #000;\n}\n\n.shopify-integration-setting-visual-editor\n  .form-container\n  .color-picker-item\n  .color-picker-item__activator.color-picker-item__activator--active\n  path {\n  fill: #007f5f;\n}\n\n.visual-editor-menu\n  .menu-container\n  .menu-container__item\n  .menu-container__item__name\n  .advanced-color\n  .Polaris-Icon {\n  width: 16px;\n  height: 16px;\n}\n\n.visual-editor-menu\n  .menu-container\n  .menu-container__item\n  .menu-container__item__name\n  .advanced-color\n  .Polaris-Icon__Svg {\n  fill: #5c5f62;\n}\n\n.color-palette-picker {\n  width: 264px;\n  min-height: 192px;\n  border-radius: 8px;\n  padding: 8px 0 16px;\n}\n\n.color-palette-picker .color-palette-picker__header {\n  padding: 8px 16px;\n}\n\n.color-palette-picker .color-palette-picker__header .title {\n  font-weight: 600;\n  font-size: 12px;\n  color: #6d7175;\n}\n\n.color-palette-picker .color-palette-picker__subheader {\n  padding: 10px 16px;\n  border-top: 1px solid #e4e5e7;\n}\n\n.color-palette-picker .color-palette-picker__subheader .title {\n  font-weight: 600;\n}\n\n.color-palette-picker .color-palette-picker__body {\n  padding: 0 16px;\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.color-palette-picker .color-palette-picker__body .color-palette-picker-item {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 1px solid #c9cccf;\n  cursor: pointer;\n}\n\n.color-palette-picker .color-palette-picker__body .color-palette-picker-item:hover,\n.color-palette-picker .color-palette-picker__body .color-palette-picker-item.active {\n  outline: 2px solid #c9cccf;\n  outline-offset: 2px;\n}\n\n.color-palette-picker .color-palette-picker__body .__react_component_tooltip {\n  box-shadow: 0px 2px 10px 0px #0000001a, 0px 0px 2px 0px #00000033;\n  max-width: 25rem;\n  padding: 4px 8px;\n  opacity: 1;\n  border-radius: 4px;\n  font-size: 12px;\n}\n\n.color-palette-picker .color-palette-picker__body .__react_component_tooltip::after,\n.color-palette-picker .color-palette-picker__body .__react_component_tooltip::before {\n  display: none;\n}\n\n#color-picker-connect {\n  white-space: nowrap;\n  padding: 4px 8px;\n  border-radius: 4px;\n  box-shadow: 0px 2px 10px 0px #0000001a, 0px 0px 2px 0px #00000033;\n  opacity: 1;\n}\n\n#color-picker-connect::after,\n#color-picker-connect::before {\n  display: none;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .form-container\n  .form-section__item__title-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n#color-contrast {\n  width: 260px;\n}\n\n/* Colors */\n\n/* Typography */\n.visual-editor-menu\n  .menu-container\n  .menu-container__item\n  .menu-container__item__name\n  .typography-section {\n  font-weight: 600;\n}\n\n.visual-editor-menu\n  .menu-container\n  .menu-container__item\n  .menu-container__item__name\n  .typography-value {\n  font-weight: 400;\n  font-size: 12px;\n}\n\n.shopify-integration-setting-visual-editor\n  .form-container\n  .typography-form\n  .BC-Select__menu\n  .BC-Select__menu-list\n  .BC-Select__group:first-child {\n  border-bottom: 1px solid #e1e3e5;\n  padding: 8px;\n  padding-bottom: 12px;\n  margin: 0 -8px;\n}\n\n.shopify-integration-setting-visual-editor\n  .form-container\n  .typography-form\n  .Polaris-TextField__Spinner {\n  display: none;\n}\n\n/* Typography */\n\n/* Menu developer */\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu-developer\n  .menu-container {\n  padding: 8px;\n  height: calc(100vh - 104px);\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body.warning\n  .visual-editor-menu-developer\n  .menu-container {\n  height: calc(100vh - 152px);\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu-developer\n  .menu-container\n  .menu-container__search {\n  margin-bottom: 22px;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body .visual-editor-code {\n  width: calc(100% - 300px);\n  height: calc(100vh - 56px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px 42px;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-body.warning .visual-editor-code {\n  height: calc(100vh - 104px);\n}\n\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__empty {\n  text-align: center;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__empty\n  .title {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 28px;\n  margin-bottom: 6px;\n  margin-top: 24px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container {\n  width: 100%;\n  height: 100%;\n  box-shadow: 0px 0px 1px 0px #00000040, 0px 2px 1px 0px #0000000d;\n  background-color: #ffffff;\n  border-radius: 8px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__col {\n  height: 100%;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__col\n  .monaco-editor-wrapper {\n  height: calc(100% - 56px - 44px);\n}\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__col\n  .monaco-editor-wrapper.monaco-editor-wrapper--error {\n  height: calc(100% - 56px - 44px - 72px);\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__files {\n  display: flex;\n  white-space: nowrap;\n  overflow: auto;\n  height: 44px;\n  border-bottom: 1px solid #e1e3e5;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__file-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__file-item\n  .Polaris-Button {\n  border: none;\n  min-width: auto;\n  min-height: auto;\n  height: 28px;\n  width: 28px;\n  padding: 0;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__file-item.editing\n  .changed-spot {\n  background-color: #008060;\n  border-radius: 100%;\n  height: 0.5rem;\n  width: 0.5rem;\n  display: block;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__file-item.editing\n  .Polaris-Button:hover\n  .changed-spot {\n  display: none;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__file-item\n  .Polaris-Icon {\n  margin: 0;\n  width: 10px;\n  height: 10px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__file-item.editing\n  .Polaris-Icon {\n  display: none;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__file-item.editing\n  .Polaris-Button:hover\n  .Polaris-Icon {\n  display: inline-block;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__file-item\n  .Polaris-Icon\n  .Polaris-Icon__Svg {\n  width: 10px;\n  height: 10px;\n  fill: #5c5f62;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__file-item:hover {\n  border-bottom: 2px solid #00806083;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__file-item.active {\n  border-bottom: 2px solid #008060 !important;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__version {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 12px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__version\n  .visual-editor-code__version-inner {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__version\n  .visual-editor-code__version-change {\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__version\n  .visual-editor-code__version-change\n  .changed-spot {\n  background-color: #5c5f62;\n  border-radius: 100%;\n  height: 0.5rem;\n  width: 0.5rem;\n  display: block;\n  position: relative;\n  top: 1px;\n}\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__version\n  .visual-editor-code__version-dropdown\n  .Polaris-Button {\n  color: rgb(32, 34, 35);\n  min-height: 1.75rem;\n  padding-top: 2px;\n  padding-bottom: 2px;\n}\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__version\n  .visual-editor-code__version-dropdown\n  .Polaris-Button:hover {\n  background-color: #f6f6f7;\n  text-decoration: none;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__version\n  .visual-editor-code__version-dropdown\n  .Polaris-Button\n  .Polaris-Button__Text {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__version\n  .visual-editor-code__version-dropdown\n  .Polaris-Button\n  .Polaris-Icon {\n  margin: 0;\n}\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__version\n  .visual-editor-code__version-dropdown\n  .Polaris-Button\n  .Polaris-Icon__Svg {\n  fill: rgb(32, 34, 35);\n}\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__version\n  .visual-editor-code__version-dropdown\n  .Polaris-Button\n  .Polaris-Spinner {\n  position: relative;\n  top: 2px;\n}\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__version\n  .visual-editor-code__version-dropdown\n  .Polaris-Button\n  .Polaris-Spinner\n  svg {\n  fill: rgb(32, 34, 35);\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__error {\n  background-color: #FFF4F4B2;\n  padding: 14px 12px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__error \n  .visual-editor-code__error__title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__error\n  .visual-editor-code__error__content {\n  padding-left: 26px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__btn-enable {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .icon-question-edit\n  .Polaris-Icon {\n  margin: 0;\n  width: 12px;\n  height: 12px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .__react_component_tooltip {\n  box-shadow: 0px 2px 10px 0px #0000001a, 0px 0px 2px 0px #00000033;\n  max-width: 25rem;\n  padding: 4px 8px;\n  opacity: 1;\n  border-radius: 4px;\n  font-size: 12px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .__react_component_tooltip::after,\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .__react_component_tooltip::before {\n  display: none;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu-developer\n  .menu-container\n  div[role='tree']\n  > div {\n  height: 100% !important;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu-developer\n  .menu-container\n  .tree-item {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu-developer\n  .menu-container\n  .tree-item\n  .Polaris-Icon {\n  margin: 0;\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu-developer\n  .menu-container\n  .tree-item-content {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  width: 100%;\n  height: 100%;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu-developer\n  .menu-container\n  .tree-item-content.edited {\n  color: #916A00;\n  background-color: #FFFBF3;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu-developer\n  .menu-container\n  .tree-item-content.edited .Polaris-Icon__Svg {\n  fill: #B98900;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu-developer\n  .menu-container\n  .tree-item-content.edited::before {\n  content: '';\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  position: absolute;\n  left: 10px;\n  background-color: #B98900;\n}\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu-developer\n  .menu-container\n  .tree-item-content.active.edited::before {\n  background-color: #008060;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu-developer\n  .menu-container\n  .tree-item-content.active {\n  color: #008060;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu-developer\n  .menu-container\n  .tree-item-content.active\n  .Polaris-Icon__Svg {\n  fill: #008060;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu-developer\n  .menu-container\n  .tree-item:hover\n  .tree-item-content,\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu-developer\n  .menu-container\n  .tree-item-content.active {\n  background-color: #f6f6f7;\n}\n\n/* Menu developer */\n\n.shopify-integration-setting-visual-editor .visual-editor-menu .source-option .source-option--flex {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-menu .source-option .source-option--link {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  margin-top: 4px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-menu\n  .source-option\n  .source-option--link\n  .Polaris-Link {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  text-decoration: none;\n  color: #2c6ecb;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-menu\n  .source-option\n  .Polaris-Badge\n  > span {\n  display: flex;\n  align-items: center;\n}\n\n.shopify-integration-setting-visual-editor .visual-editor-menu .form-section__item--flex-between {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-code\n  .visual-editor-code__container\n  .visual-editor-code__col .btn-compare.btn-compare--active .Polaris-Button {\n  background-color: #F2F7FE;\n  color: #2C6ECB;\n  border-color: transparent;\n}\n\n/* app wishlist integration */\n.form-section__item-integrated-app {\n  margin-left: 28px;\n  background-color: #F6F6F7;\n  border-radius: 6px;\n  padding: 8px;\n}\n\n.form-section__item-integrated-app .form-title-content {\n  margin-right: 6px;\n  font-weight: 600;\n}\n\n.icon-app-wishlist__container {\n  margin-top: 4px;\n}\n\n.icon-app-wishlist__item-app-name {\n  margin-top: 0;\n  flex: 1 1 0;\n  min-height: 0;\n} \n\n.icon-app-wishlist__container-empty {\n  margin-top: 14px;\n  color: #6D7175;\n}\n\n.icon-app-wishlist__item img {\n  width: 32px;\n  height: 32px;\n  border-radius: 4px;\n}\n\n.icon-app-wishlist__item-config-link {\n  text-decoration: underline;\n}\n\n.icon-app-wishlist__item-dot {\n  color: #2c6ecb;\n}\n.shopify-integration-setting-visual-editor .BC-Toggle-Switch-Button .Polaris-Labelled__LabelWrapper {\n  margin-left: 16px;\n}\n\n.widget-visual-editor .visual-editor-body #preview-shopify-integration-setting-cart.preview-cart--mobile {\n  width: 497px !important;\n  top: 54px;  \n  left: 45%;\n  border: 0;\n  height: calc(100% - 54px);\n}\n.widget-visual-editor .visual-editor-body #preview-shopify-integration-setting-cart.preview-cart--mobile.preview-cart--side {\n  width: 324px !important;\n  left: 50%;\n}\n\n.widget-visual-editor .visual-editor-body #preview-shopify-integration-setting-cart.preview-cart--fullscreen {\n  width: 100%;\n  left: 0;\n}\n\n.widget-visual-editor\n  .visual-editor-body\n  #preview-shopify-integration-setting-cart {\n  height: 100%;\n  width: 324px;\n  border: 0;\n}\n\n.widget-visual-editor\n  .visual-editor-body\n  #preview-shopify-integration-setting-cart.preview-cart--popup {\n  width: 960px;\n}\n\n\n.widget-visual-editor\n  .visual-editor-body\n  .cart-drawer-preview-container \n  .visual-editor-preview {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 0;\n    height: 100%;\n    margin-top: 1rem;\n}\n\n.widget-visual-editor\n  .visual-editor-body\n  .visual-editor-preview\n  .visual-editor-preview__overlay-cart {\n    flex-grow: 1;\n    display: flex;\n    justify-content: center;\n}\n\n.widget-visual-editor\n  .visual-editor-body .visual-editor-preview .Polaris-SkeletonThumbnail {\n    width: 320px;\n    height: 100%;\n}\n\n.widget-visual-editor\n  .visual-editor-body .visual-editor-preview  .preview-shopify-integration-setting-cart__skeleton--popup {\n    margin: auto;\n}\n\n.widget-visual-editor\n  .visual-editor-body .visual-editor-preview  .preview-shopify-integration-setting-cart__skeleton--popup\n  .Polaris-SkeletonThumbnail {\n    width: 960px;\n    height: 520px;\n}\n\n\n.shopify-integration-setting-visual-editor .visual-editor-warning {\n  background-color: #FFFBF3;\n  width: 100%;\n  padding: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu .cart-layout {\n  margin-top: 16px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu .cart-layout > div {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu .cart-layout > div:first-of-type {\n  margin-top: 6px;\n  margin-bottom: 8px;\n}\n\n.shopify-integration-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-menu .cart-layout .Polaris-Icon {\n  margin: 0;\n  width: 10px;\n  height: 10px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
